export type Lang = 'TH' | 'EN'

interface LangStrings {
  nav: {
    saveAndExit: string
    exit: string
    chatWithUs: string
    chatOnline: string
    langToggle: string
  }
  stepNames: {
    info: string
    proInfo: string
    parking: string
    earn: string
    photo: string
    document: string
    review: string
    appointment: string
  }
  dialogs: {
    closeNew: {
      title: string
      content: string
      ok: string
      cancel: string
    }
    closeSaved: {
      title: string
      content: string
      ok: string
      cancel: string
    }
  }
  required: string
  step1: {
    pageTitle: string
    pageSubtitle: string
    vehicleBrand: string
    vehicleModel: string
    vehicleYear: string
    licensePlate: string
    province: string
    vehicleColor: string
    vehicleColorNote: string
    optional: string
    transmission: string
    keyType: string
    keyTypeKey: string
    keyTypePush: string
    fuelType: string
    mileage: string
    taxExpireDate: string
    vinNo: string
    back: string
    next: string
    licensePlateFormat: string
    loading: string
    seeMore: string
    showLess: string
    kmUnit: string
    transmissionAuto: string
    transmissionManual: string
    duplicatePlateExists: string
    duplicatePlateCheckFailed: string
    brandModalTitle: string
    brandSearchPlaceholder: string
    brandNoData: string
    brandNoResult: string
    modelModalTitle: string
    modelSearchPlaceholder: string
    modelNoData: string
    modelNoResult: string
    modelLoading: string
    subModelModalTitle: string
    welcomeModal: {
      stepNumber: string
      title: string
      description: string
      proDescription: string
      imageAlt: string
      backButton: string
      nextButton: string
    }
  }
  step2: {
    confirmOk: string
    confirmCancel: string
    selectedPoint: string
    searchingSpot: string
    back: string
    next: string
    selectParking: string
    parkingModal: {
      stepNumber: string
      title: string
      description: string
      imageAlt: string
      nextButton: string
      backButton: string
    }
  }
  step3: {
    loadingPrice: string
    submitting: string
    bannerTitle: string
    bannerText: string
    offerRentalsTitle: string
    offerRentalsQuestion: string
    shortTermDefault: string
    longTerm: string
    netRevenueTitle: string
    netRevenueDesc: string
    pricingUnavailableTitle: string
    pricingUnavailableDesc: string
    setPriceTitle: string
    enableHaupSuggestion: string
    perDay: string
    perWeek: string
    perMonth: string
    perYear: string
    maxRentalDuration: string
    priceRangeNote: string
    priceNetNote: string
    standardPriceLink: string
    longTermPriceTitle: string
    depositTitle: string
    depositNote: string
    depositYes: string
    depositNo: string
    depositAmount: string
    depositSuggested: string
    proTitle: string
    proText: string
    proLink: string
    consentText: string
    consentLink: string
    back: string
    save: string
    continueBtn: string
    priceError: string
    priceExceedDailyError: string
    skipAndSubmit: string
    continueNext: string
    completedTitle: string
    completedText: string
    step1Done: string
    step2Done: string
    step3Done: string
    additionalStepsTitle: string
    additionalStepsNote: string
    step4Title: string
    step4Note: string
    step5Title: string
    step5Note: string
    stdPriceModalTitle: string
    stdPriceModalDesc: string
    perDayLabel: string
    perWeekLabel: string
    perMonthLabel: string
    perYearLabel: string
    perDayUnit: string
    perWeekUnit: string
    perMonthUnit: string
    totalLabel: string
    daysLabel: string
    noData: string
    closeButton: string
    proModalTitle: string
    proModalDesc: string
    proPackageLabel: string
    proPackageNow: string
    proYourShare: string
    proPlatformFee: string
    proBenefitsTitle: string
    proBenefits: string[]
    tcTitle: string
    tcNotFound: string
    longTermInfoTitle: string
    longTermInfoDesc: string
    longTermBenefitsTitle: string
    longTermBenefit1: string
    longTermBenefit2: string
    longTermBenefit3: string
    earnModal: {
      stepNumber: string
      proStepNumber: string
      title: string
      description: string
      imageAlt: string
      nextButton: string
      backButton: string
    }
    skipModal: {
      year: string
      month9: string
      month6: string
      month3: string
      month1: string
    }
  }
  step4: {
    pageTitle: string
    pageSubtitle: string
    photoTip1: string
    photoTip2: string
    photoTip3: string
    cardPreviewTitle: string
    noPhotos: string
    uploadTitle: string
    frontSide: string
    backSide: string
    front: string
    leftSide: string
    rightSide: string
    back: string
    cabin: string
    skipAndSubmit: string
    submitting: string
    loading: string
    backBtn: string
    next: string
  }
  step5: {
    pageTitle: string
    pageSubtitle: string
    idCard: string
    q1: string
    q2Company: string
    q2Personal: string
    q3CompanyOwner: string
    q3CompanyNonOwner: string
    q3PersonalOwner: string
    q3PersonalNonOwner: string
    yes: string
    no: string
    companyCert: string
    companyAuthorize: string
    vehicleAuthorize: string
    vehicleReg: string
    taxBadge: string
    bankBook: string
    bankBookAlt: string
    bankUsageAuth: string
    authorizeTemplate: string
    skipAndSubmit: string
    submitting: string
    loading: string
    back: string
    next: string
  }
  welcomeOverview: {
    title: string
    step1Label: string
    step1Desc: string
    step1IconAlt: string
    step2Label: string
    step2Desc: string
    step2IconAlt: string
    step3Label: string
    step3Desc: string
    step3IconAlt: string
    additionalTitle: string
    additionalStep1: string
    additionalStep2: string
    skipButton: string
    getStarted: string
  }
  welcomeOverviewPro: {
    title: string
    step1Label: string
    step1Desc: string
    step1IconAlt: string
    step2Label: string
    step2Desc: string
    step2IconAlt: string
    step3Label: string
    step3Desc: string
    step3IconAlt: string
    whatsNextLabel: string
    requiredLabel: string
    requiredStep1: string
    requiredStep2: string
    requiredStep3: string
    getStarted: string
  }
  listing: {
    pageTitle: string
    tabVehicles: string
    tabActivities: string
    tabProperty: string
    lineChat: string
    lineAdd: string
    emptyTitle: string
    emptyDesc: string
    sectionActionRequired: string
    sectionIncomplete: string
    sectionPending: string
    sectionCompleted: string
    sectionPublished: string
    sectionCarSubmits: string
    sectionUnqualified: string
    noData: string
    registerBtn: string
    addModalTitle: string
    addModalDesc: string
    vehicleOption: string
    vehicleOptionDesc: string
    activityOption: string
    activityOptionDesc: string
    propertyOption: string
    propertyOptionDesc: string
    vehicleTypeTitle: string
    vehicleTypeDesc: string
    countryLabel: string
    countryThailand: string
    countryIndonesia: string
    individualOwner: string
    individualOwnerDesc: string
    rentalBusiness: string
    rentalBusinessDesc: string
    lineConnectTitle: string
    lineConnectDesc: string
    lineConnectBtn: string
    statusIncomplete: string
    statusActionRequired: string
    statusPending: string
    statusSubmitted: string
    statusCompleted: string
    statusVerified: string
    statusPublished: string
    statusUnknown: string
    lastEdited: string
    uploadDocuments: string
    continueBtn: string
    manageBtn: string
    viewBtn: string
    carSubmitAccepted: string
    carSubmitRejected: string
    carSubmitPending: string
    carSubmitSentOn: string
    carSubmitContinue: string
    pullToRefresh: string
    releaseToRefresh: string
    refreshing: string
    refreshComplete: string
    proIntro: {
      title: string
      subtitle: string
      proLabel: string
      proBadge: string
      proBullet1: string
      proBullet2: string
      proBullet3: string
      proBullet4: string
      proBullet5: string
      learnMoreRevenuePlans: string
      proNote: string
      learnMorePro: string
      starterLabel: string
      starterBullet1: string
      starterBullet2: string
      starterBullet3: string
      starterBullet4: string
      starterBullet5: string
      learnMoreStarter: string
      continueWithProBtn: string
      continueWithStarterBtn: string
      earningsCalculator: {
        entryTitle: string
        entrySubtitle: string
        modalTitle: string
        modalSubtitle: string
        brandLabel: string
        brandPlaceholder: string
        modelLabel: string
        modelPlaceholder: string
        yearLabel: string
        yearPlaceholder: string
        calculateBtn: string
        resultsTitle: string
        resultsSubtitle: string
        perDayRateLabel: string
        perDayRateNote: string
        perMonthRateLabel: string
        perMonthRateNote: string
        standardPricingNote: string
        starterLabel: string
        proLabel: string
        utilisationRateLabel: string
        estRentalDaysLabel: string
        estIncomeLabel: string
        listedOnlyOnLabel: string
        listedOnLabel: string
        proUtilisationBannerTitle: string
        proUtilisationBannerSubtitle: string
        disclaimer: string
        continueWithProBtn: string
        backToOverviewBtn: string
        notFoundError: string
      }
      planDetails: {
        backBtn: string
        featureListLabel: string
        starterColLabel: string
        proColLabel: string
        featureRows: { label: string; starter: string; pro: string }[]
        pro: {
          title: string
          bullets: string[]
          linkLabel: string
          linkAfterIndex: number
        }
        starter: {
          title: string
          bullets: string[]
          linkLabel: string
          linkAfterIndex: number
        }
      }
      revenuePlans: {
        title: string
        subtitle: string
        plan5545Title: string
        plan5545Subtitle: string
        plan5545Desc: string
        plan5050Title: string
        plan5050Subtitle: string
        plan5050Desc: string
        featuresLabel: string
        col5050Label: string
        col5545Label: string
        rows: {
          label: string
          col1Check?: boolean
          col2Check?: boolean
          col1Text?: string
          col2Text?: string
        }[]
      }
      netRevenue: {
        title: string
        description: string
        exampleLabel: string
        exampleIntro: string
        bullet1: string
        bullet2: string
        bullet3: string
        noteText: string
      }
      iotDevice: {
        title: string
        subtitle: string
        deviceTitle: string
        deviceDesc: string
        compatibleTitle: string
        moreLabel: string
        whyTitle: string
        features: { title: string; desc: string }[]
        installationFeeLabel: string
        installationFeeValue: string
        installationFeeNote: string
        dueTodayLabel: string
        dueTodayValue: string
        dueTodayNote: string
        installmentText: string
        payBtn: string
        goBackBtn: string
      }
      takeALook: {
        title: string
        subtitle: string
        featureLabel: string
        proLabel: string
        starterLabel: string
        rows: { label: string; proCheck: boolean; starterCheck: boolean }[]
        note: string
        switchToProBtn: string
        continueStarterBtn: string
      }
      payment: {
        title: string
        subtitle: string
        infoNote: string
        paymentDetailsLabel: string
        depositLabel: string
        processingFeeLabel: string
        processingFeeNote: string
        totalLabel: string
        selectMethodLabel: string
        cardLabel: string
        scbPromptPayLabel: string
        alipayLabel: string
        wechatPayLabel: string
        qrPromptPayLabel: string
        cardNumberLabel: string
        cardNumberPlaceholder: string
        cardHolderLabel: string
        cardHolderPlaceholder: string
        expiryLabel: string
        cvvLabel: string
        payBtnPrefix: string
        payBtnSuffix: string
        processingBtn: string
        depositBannerTitle: string
        depositBannerDesc: string
        depositBannerCta: string
        alreadyPaidTitle: string
        alreadyPaidDesc: string
        alreadyPaidContinue: string
        processingModalTitle: string
        processingModalDesc: string
        goBackBtn: string
        qrModalTitle: string
        qrModalSubtitle: string
        qrWaitingText: string
        qrNote: string
      }
    }
  }
  finish: {
    loadingText: string
    submittingTitle: string
    submittingDesc: string
    noVehicleData: string
    requestBookingBadge: string
    instantBookingBadge: string
    meetWithOwner: string
    appUnlock: string
    seatsLabel: string
    successTitle: string
    viewCarBtn: string
    lineTitle: string
    lineDesc: string
    lineChat: string
    stepsTitle: string
    step1Title: string
    step2Title: string
    step3Title: string
    step3Desc: string
    step3ManageBtn: string
    step3DownloadBtn: string
    incompleteBadge: string
    doneBtn: string
    manageBtn: string
    proAllSetTitle: string
    proAllSetSubtitle: string
    proIotScheduledTitle: string
    proStartEarningTitle: string
    proStartEarningDesc: string
    proStepSubmitCarInfo: string
    proStepSetPricing: string
    proStepScheduleIot: string
    proStepDownloadApp: string
    proStepUploadImagesDocs: string
    proStepSignContract: string
    proStepCompleteIot: string
    proStepSelectParking: string
    proManageBtn: string
    proFinishBtn: string
  }
  paymentCallback: {
    processingTitle: string
    processingDesc: string
    successTitle: string
    successDesc: string
    refIdLabel: string
    whatsNextLabel: string
    step1: string
    step2: string
    failedTitle: string
    failedDesc: string
    continueBtn: string
    closeBtn: string
  }
  proPricing: {
    revenuePlanTitle: string
    plan5050Label: string
    plan5545Label: string
    plan5050Tagline: string
    plan5545Tagline: string
    airtimeIncluded: string
    airtimeNotIncluded: string
    maintenanceIncluded: string
    operationsManaged: string
    idealForLabel: string
    plan5050IdealFor: string
    plan5545IdealFor: string
    learnMorePlan: string
    comparePlans: string
    whatsIncludedLabel: string
    plan5050ModalDesc: string
    plan5545ModalDesc: string
    plan5050Benefits: string[]
    plan5545Benefits: string[]
    insuranceQuestion: string
    insuranceYes: string
    insuranceNo: string
    insuranceTypeQuestion: string
    insurancePersonal: string
    insuranceCommercial: string
    insurancePackageTitle: string
    insurancePackageMostPick: string
    insurancePackageDesc: string
    monthsLabel: string
    standardPriceSectionTitle: string
  }
  proReview: {
    title: string
    subtitle: string
    revenueShareLabel: string
    dailyLabel: string
    weeklyLabel: string
    monthlyLabel: string
    yearlyLabel: string
    perDay: string
    perWeek: string
    perMonth: string
    perYear: string
    iotScheduleTitle: string
    submitBtn: string
  }
  proAppointment: {
    title: string
    subtitle: string
    selectDateTimeLabel: string
    selectTimeLabel: string
    garageName: string
    garageAddress: string
    directionsLink: string
    durationNote: string
    confirmBtn: string
    goBackBtn: string
    exitBtn: string
    welcomeModal: {
      stepNumber: string
      title: string
      description: string
      imageAlt: string
      nextButton: string
      backButton: string
    }
  }
}

export const submissionTranslations: Record<Lang, LangStrings> = {
  TH: {
    nav: {
      saveAndExit: 'บันทึกและออก',
      exit: 'ออก',
      chatWithUs: 'แชทกับเรา',
      chatOnline: 'แชทออนไลน์',
      langToggle: 'EN',
    },
    stepNames: {
      info: 'คุณสนใจจะปล่อยเช่ารถประเภทใด?',
      proInfo: 'แจ้งข้อมูลเกี่ยวกับรถของคุณ',
      parking: 'เพิ่มที่จอดรถ',
      earn: 'ตั้งราคาค่าเช่ารถ',
      photo: 'รูปรถ',
      document: 'เอกสาร',
      review: 'ตรวจสอบข้อมูลของคุณ',
      appointment: 'นัดหมายการติดตั้ง IoT',
    },
    dialogs: {
      closeNew: {
        title: 'คุณต้องการปิดหน้านี้หรือไม่ ?',
        content: 'ข้อมูลของคุณจะยังไม่ถูกบันทึกหลังจากปิดหน้านี้ (จะบันทึกเมื่อไปถึงหน้าถัดไป)',
        ok: 'ใช่',
        cancel: 'ไม่',
      },
      closeSaved: {
        title: 'คุณต้องการปิดหน้านี้หรือไม่ ?',
        content: 'ข้อมูลของคุณจะถูกบันทึก คุณสามารถกลับมาทำต่อได้ในภายหลัง',
        ok: 'บันทึกและปิด',
        cancel: 'ไม่',
      },
    },
    required: 'ห้ามเว้นว่าง',
    step1: {
      pageTitle: 'คุณสนใจจะปล่อยเช่ารถประเภทใด?',
      pageSubtitle: 'รถยนต์ที่นำเข้าร่วมบริการต้องมีอายุไม่เกิน 10 ปี นับจากวันที่จดทะเบียนรถยนต์',
      vehicleBrand: 'ยี่ห้อรถ',
      vehicleModel: 'รุ่นรถ',
      vehicleYear: 'ปีจดทะเบียน',
      licensePlate: 'เลขทะเบียน',
      province: 'จังหวัด',
      vehicleColor: 'สีของรถ',
      vehicleColorNote: 'กรุณาเลือกสีรถให้ตรงกับสีที่ระบุไว้ในเล่มทะเบียนรถ',
      optional: 'เพิ่มรายละเอียดรถเพิ่มเติม (ไม่บังคับ)',
      transmission: 'เกียร์',
      keyType: 'การสตาร์ทเครื่องยนต์',
      keyTypeKey: 'ใช้กุญแจ',
      keyTypePush: 'กดปุ่ม',
      fuelType: 'ชนิดของน้ำมัน',
      mileage: 'เลขไมล์',
      taxExpireDate: 'วันที่หมดอายุภาษี',
      vinNo: 'เลขตัวถัง',
      back: 'กลับ',
      next: 'ต่อไป',
      licensePlateFormat: 'รูปแบบเลขทะเบียนไม่ถูกต้อง',
      loading: 'กำลังโหลด...',
      seeMore: 'ดูเพิ่มเติม',
      showLess: 'แสดงน้อยลง',
      kmUnit: 'กม.',
      transmissionAuto: 'อัตโนมัติ',
      transmissionManual: 'ธรรมดา',
      duplicatePlateExists: 'ป้ายทะเบียนมีอยู่ในระบบแล้ว ลงทะเบียนด้วยอีเมล',
      duplicatePlateCheckFailed: 'ไม่สามารถตรวจสอบป้ายทะเบียนได้ กรุณาลองอีกครั้ง',
      brandModalTitle: 'เลือกยี่ห้อรถ',
      brandSearchPlaceholder: 'ค้นหายี่ห้อรถ...',
      brandNoData: 'ไม่มีข้อมูลยี่ห้อรถ',
      brandNoResult: 'ไม่พบยี่ห้อรถที่ค้นหา',
      modelModalTitle: 'เลือกรุ่นรถ',
      modelSearchPlaceholder: 'ค้นหารุ่นรถ...',
      modelNoData: 'ไม่มีข้อมูลรุ่นรถ',
      modelNoResult: 'ไม่พบรุ่นรถที่ค้นหา',
      modelLoading: 'กำลังโหลดรุ่นรถ...',
      subModelModalTitle: 'เลือกรุ่นย่อย',
      welcomeModal: {
        stepNumber: 'ขั้นตอนที่ 1',
        title: 'แจ้งข้อมูลเกี่ยวกับรถของคุณ',
        description:
          'คุณจะต้องกรอกรายละเอียดพื้นฐานเกี่ยวกับรถของคุณ รวมถึงยี่ห้อ รุ่น ปี และที่ตั้ง คุณยังสามารถเพิ่มคุณสมบัติสำคัญ เช่น ประเภทเชื้อเพลิง ระบบเกียร์ หรือฟังก์ชันพิเศษต่างๆ ข้อมูลเหล่านี้จะช่วยให้ผู้เช่าทราบว่าพวกเขากำลังจองรถแบบไหนและสามารถไปรับรถได้ที่ไหน',
        proDescription:
          'คุณจะต้องกรอกรายละเอียดพื้นฐานเกี่ยวกับรถของคุณ รวมถึงยี่ห้อ รุ่น ปี และสี คุณยังสามารถเพิ่มคุณสมบัติสำคัญ เช่น ประเภทเชื้อเพลิง ระบบเกียร์ หรือฟังก์ชันพิเศษต่างๆ ข้อมูลเหล่านี้จะช่วยให้ผู้เช่าทราบว่าพวกเขากำลังจองรถแบบไหน',
        imageAlt: 'ภาพประกอบรถยนต์',
        backButton: 'กลับ',
        nextButton: 'ถัดไป',
      },
    },
    step2: {
      confirmOk: 'ตกลง',
      confirmCancel: 'ยกเลิก',
      selectedPoint: 'จุดส่งรถที่เลือก',
      searchingSpot: 'กำลังค้นหาจุดจอด',
      back: 'กลับ',
      next: 'ต่อไป',
      selectParking: 'เลือกที่จอด',
      parkingModal: {
        stepNumber: 'ขั้นตอนที่ 2',
        title: 'เพิ่มตำแหน่งที่ตั้งรถของคุณ',
        description:
          'คุณจะต้องระบุตำแหน่งที่รถของคุณจอดประจำ เช่น บ้าน คอนโด หรือลานจอดรถสาธารณะ ตำแหน่งนี้จะช่วยให้ผู้เช่าทราบว่าสามารถไปรับและส่งคืนรถได้ที่ไหน การระบุตำแหน่งที่ชัดเจนและถูกต้องจะช่วยเพิ่มความน่าเชื่อถือ เพิ่มโอกาสในการจอง และทำให้การส่งมอบรถเป็นไปอย่างราบรื่น',
        imageAlt: 'ภาพประกอบตำแหน่งที่ตั้งรถ',
        nextButton: 'ถัดไป',
        backButton: 'กลับ',
      },
    },
    step3: {
      loadingPrice: 'กำลังโหลดข้อมูลราคา...',
      submitting: 'กำลังส่งข้อมูลของคุณ...',
      bannerTitle: 'เพิ่มรายได้ของคุณได้มากขึ้น ด้วยการปล่อยเช่ารถระยะยาว!',
      bannerText:
        'เพิ่มตัวเลือกในการปล่อยเช่า เพียงเปิดบริการปล่อยเช่าแบบระยะยาว ก็มีสิทธิ์สร้างรายได้ ได้อย่างต่อเนื่อง',
      offerRentalsTitle: 'ตัวเลือกการเช่า',
      offerRentalsQuestion: 'คุณต้องการเสนอตัวเลือกการเช่าเพิ่มเติมหรือไม่?',
      shortTermDefault: 'การเช่ารถระยะสั้น (ค่าเริ่มต้น)',
      longTerm: 'การเช่ารถระยะยาว',
      netRevenueTitle: 'ราคาสุทธิ ( Net Revenue )',
      netRevenueDesc:
        'ราคาสุทธิ ( Net Revenue ) คือ ราคารายได้สุทธิที่ทางท่านเจ้าของรถจะได้รับ โดย มีการหักแค่ ภาษี ณ ที่จ่าย 3% เท่านั้น',
      pricingUnavailableTitle: 'ไม่สามารถแสดงราคาแนะนำได้',
      pricingUnavailableDesc:
        'ข้อมูลราคาสำหรับยานพาหนะนี้ยังไม่มีในระบบของเราในขณะนี้ เพื่อให้แน่ใจว่าได้รับอัตราที่แม่นยำและมีการแข่งขัน กรุณาติดต่อเราเพื่อรับการสนับสนุนด้านการกำหนดราคาแบบแมนนวล',
      setPriceTitle: 'ตั้งค่าราคารายได้สุทธิ',
      enableHaupSuggestion: 'เปิดใช้งานการแนะนำราคาจาก HAUP',
      perDay: 'รายวัน',
      perWeek: 'รายสัปดาห์',
      perMonth: 'รายเดือน',
      perYear: 'รายปี',
      maxRentalDuration: 'ระยะเวลาการเช่าสูงสุด',
      priceRangeNote: 'ราคาที่ถูกตั้งค่าจะต้องอยู่ในช่วง -30% ถึง +30% จากราคามาตรฐาน',
      priceNetNote:
        'ราคาที่คุณตั้งไว้ที่นี่สะท้อนถึงรายได้สุทธิของคุณหลังจากหักค่าบริการแล้ว ดังนั้นจึงอาจแตกต่างจากราคาที่แสดงให้ผู้เช่าเห็นในแอป HAUP',
      standardPriceLink: 'ราคาค่าเช่ามาตรฐานจาก HAUP',
      longTermPriceTitle: 'ราคาสำหรับการเช่ารถระยะยาว',
      depositTitle: 'คุณต้องการให้เก็บเงินประกันจากผู้เช่าไหม?',
      depositNote: 'ดึงดูดการจองมากขึ้นโดยการให้ตัวเลือกไม่ต้องมีเงินประกันกับผู้เช่า',
      depositYes: 'ใช่ เก็บเงินประกันสำหรับรถของฉัน',
      depositNo: 'ไม่มีเงินประกัน (แนะนำ)',
      depositAmount: 'จำนวนเงินประกัน',
      depositSuggested: 'แนะนำสำหรับรถขนาด',
      proTitle: 'สนใจอัพเกรตเป็นแพ็กเกจโปรภายหลังไหม?',
      proText: 'คุณต้องการปรับเปลี่ยนเป็นแพ็กเกจโปรภายหลังจากการเข้ามาเป็น แพคเกจไหม',
      proLink: 'ดูข้อมูลแพ็กเกจโปร',
      consentText: 'กรุณาอ่านและยอมรับ',
      consentLink: 'ข้อกำหนดและเงื่อนไข',
      back: 'กลับ',
      save: 'บันทึก',
      continueBtn: 'ดำเนินการต่อ',
      priceError: 'กรุณากรอกราคา',
      priceExceedDailyError: 'ราคาต้องไม่เกินราคารายวัน',
      skipAndSubmit: 'ข้ามและส่ง',
      continueNext: 'ดำเนินการต่อ',
      completedTitle: 'คุณได้ทำขั้นตอนหลักเสร็จสิ้นแล้ว!',
      completedText: 'คุณได้ทำขั้นตอนที่จำเป็นครบถ้วนแล้ว รถของคุณพร้อมให้บริการและรอการจองแล้ว',
      step1Done: 'บอกเราเกี่ยวกับตัวคุณ',
      step2Done: 'เพิ่มที่ตั้งรถของคุณ',
      step3Done: 'ตั้งราคาและรายได้ของคุณ',
      additionalStepsTitle: 'ทำขั้นตอนเหล่านี้ได้ตลอดเวลา',
      additionalStepsNote:
        'คุณสามารถข้ามไปตอนนี้ได้ แต่การทำให้เสร็จจะช่วยเพิ่มการมองเห็นและความน่าเชื่อถือของรายการของคุณ',
      step4Title: 'แสดงรถของคุณในมุมที่ดีที่สุด',
      step4Note: 'อัพโหลดรูปรถที่ชัดเจน - ทั้งภายในและภายนอก เพื่อดึงดูดผู้เช่า',
      step5Title: 'อัพโหลดเอกสาร',
      step5Note:
        'อัพโหลดเอกสารที่จำเป็นเพื่อยืนยันรถของคุณและสร้างความเชื่อมั่นให้กับกระบวนการเช่า',
      stdPriceModalTitle: 'ราคาแนะนำจาก HAUP',
      stdPriceModalDesc: 'ตารางด้านล่างแสดงราคาเฉลี่ยที่กำหนดโดยเจ้าของรถ',
      perDayLabel: 'รายวัน',
      perWeekLabel: 'รายสัปดาห์',
      perMonthLabel: 'รายเดือน',
      perYearLabel: 'รายปี',
      perDayUnit: 'ต่อวัน',
      perWeekUnit: 'ต่อสัปดาห์',
      perMonthUnit: 'ต่อเดือน',
      totalLabel: 'ยอดรวม',
      daysLabel: 'วัน',
      noData: 'ไม่มีข้อมูล',
      closeButton: 'ปิด',
      proModalTitle: 'รายละเอียดแพ็กเกจโปร',
      proModalDesc: 'ค่าธรรมเนียมแพคเกจ Pro',
      proPackageLabel: 'แพ็กเกจโปร',
      proPackageNow: 'ตอนนี้',
      proYourShare: 'รายรับของคุณ',
      proPlatformFee: 'ค่าบริการแพลตฟอร์ม',
      proBenefitsTitle: 'สิทธิประโยชน์แพ็กเกจโปร',
      proBenefits: [
        'รวม GPS',
        'รวมอุปกรณ์ปลดล็อค IoT',
        'เช่ารายชั่วโมง',
        'จองรถได้ทันที',
        'ปลดล็อครถยนต์ผ่านแอพ Haup',
        'ประกันภัยรายเดือนหรือรายปี',
      ],
      tcTitle: 'ข้อกำหนดและเงื่อนไข',
      tcNotFound: 'ไม่พบข้อกำหนดและเงื่อนไข',
      longTermInfoTitle: 'การปล่อยเช่ารถระยะยาว',
      longTermInfoDesc:
        'เปิดให้บริการการเช่าระยะยาว - เพื่อให้เกิดการเช่ารถรายเดือน - รายปี เพื่อให้ลูกค้างลุ่มธุรกิจ หรือผู้ย้ายถิ่นที่อยู่ เช่าใช้งานระยะยาว เพื่อความสะดวกในการเดินทาง',
      longTermBenefitsTitle: 'ประโยชน์ของการเสนอการเช่ารถระยะยาว',
      longTermBenefit1: 'รับรายได้คงที่จากการจองระยะยาว',
      longTermBenefit2: 'ลดช่วงเวลาว่างระหว่างการเช่า',
      longTermBenefit3: 'ดึงดูดลูกค้าองค์กรและผู้เช่าระยะยาว',
      earnModal: {
        stepNumber: 'ขั้นตอนที่ 3',
        proStepNumber: 'ขั้นตอนที่ 2',
        title: 'ตั้งราคาและรายได้ของคุณ',
        description:
          'คุณจะต้องกำหนดราคาค่าเช่าและความพร้อมใช้งานที่คาดหวัง ซึ่งจะช่วยให้คุณตัดสินใจได้ว่าต้องการรายได้จากรถของคุณเท่าไร HAUP จะให้การประมาณรายได้ตามราคาที่คุณกำหนดและการใช้งานรถ เพื่อช่วยให้คุณตัดสินใจอย่างมีข้อมูลและเพิ่มรายได้ให้สูงสุด',
        imageAlt: 'ภาพประกอบราคาและรายได้',
        nextButton: 'ถัดไป',
        backButton: 'กลับ',
      },
      skipModal: {
        year: '1 ปี',
        month9: '9 เดือน',
        month6: '6 เดือน',
        month3: '3 เดือน',
        month1: '1 เดือน',
      },
    },
    step4: {
      pageTitle: 'รูปรถของคุณ',
      pageSubtitle: 'รูปรถที่สวยงามจะช่วยให้รถของคุณน่าสนใจมากยิ่งขึ้น เราขอแนะนำให้คุณ:',
      photoTip1: 'ถ่ายรูปในอัตราส่วน 4:3 แนวนอน',
      photoTip2: 'ให้รถอยู่ตรงกลางภาพ',
      photoTip3: 'ถ่ายรูปให้เห็นรถอย่างชัดเจน',
      cardPreviewTitle: 'ตัวอย่างการ์ดรถของคุณ',
      noPhotos: 'คุณยังไม่ได้อัปโหลดรูป',
      uploadTitle: 'อัพโหลดรูปรถ',
      frontSide: 'มุมเฉียงด้านหน้า',
      backSide: 'มุมเฉียงด้านหลัง',
      front: 'มุมตรงด้านหน้า',
      leftSide: 'มุมข้างฝั่งคนนั่ง',
      rightSide: 'มุมข้างฝั่งคนขับ',
      back: 'มุมตรงด้านหลัง',
      cabin: 'รูปภายในตัวรถ (อัพโหลดได้มากกว่า 1 รูป)',
      skipAndSubmit: 'ข้ามและส่งข้อมูล',
      submitting: 'กำลังส่งข้อมูล...',
      loading: 'กำลังโหลด...',
      backBtn: 'กลับ',
      next: 'ต่อไป',
    },
    step5: {
      pageTitle: 'การอัพโหลดเอกสาร',
      pageSubtitle: 'โปรดอัพโหลดเอกสารดังกล่าวเพื่อประกอบการทำสัญญาการปล่อยเช่ารถ',
      idCard: 'บัตรประชาชนของคุณ',
      q1: 'รถของคุณจดทะเบียนในนามบริษัทหรือไม่ ?',
      q2Company: 'คุณมีชื่อเป็นกรรมการบริหารของบริษัทนั้นหรือไม่ ?',
      q2Personal: 'คุณมีชื่อเป็นเจ้าของรถคันนี้หรือไม่ ?',
      q3CompanyOwner: 'เจ้าของบัญชีธนาคารคือชื่อบริษัทหรือกรรมการบริหารบริษัทหรือไม่ ?',
      q3CompanyNonOwner: 'เจ้าของบัญชีธนาคารคือชื่อบริษัทหรือผู้ปล่อยเช่ารถหรือไม่ ?',
      q3PersonalOwner: 'เจ้าของบัญชีธนาคารเป็นชื่อเดียวกันกับเจ้าของรถหรือไม่ ?',
      q3PersonalNonOwner:
        'เจ้าของบัญชีธนาคารเป็นชื่อเดียวกันกับเจ้าของรถหรือผู้ปล่อยเช่ารถหรือไม่ ?',
      yes: 'ใช่',
      no: 'ไม่ใช่',
      companyCert: 'หนังสือรับรองบริษัท',
      companyAuthorize: 'ใบมอบอำนาจจากบริษัท',
      vehicleAuthorize: 'ใบมอบอำนาจจากเจ้าของรถ',
      vehicleReg: 'เล่มทะเบียนรถ',
      taxBadge: 'ป้ายภาษี',
      bankBook: 'บุ๊คแบงค์',
      bankBookAlt: 'หน้าสมุดบัญชีธนาคาร',
      bankUsageAuth: 'เอกสารยินยอมจากเจ้าของบัญชี',
      authorizeTemplate: 'ตัวอย่างใบมอบอำนาจ',
      skipAndSubmit: 'ข้ามและส่งข้อมูล',
      submitting: 'กำลังส่งข้อมูลของคุณ...',
      loading: 'กำลังโหลด...',
      back: 'กลับ',
      next: 'ต่อไป',
    },
    welcomeOverview: {
      title: 'แชร์รถของคุณใน 3 ขั้นตอนง่ายๆ เพื่อลิสต์บนแพลตฟอร์ม',
      step1Label: '1. บอกเราเกี่ยวกับรถของคุณ',
      step1Desc: 'เพิ่มรายละเอียด เช่น ยี่ห้อ รุ่น ปี และสี เพื่อช่วยให้ผู้เช่ารู้ว่าจะได้อะไร',
      step1IconAlt: 'ไอคอนข้อมูลรถ',
      step2Label: '2. เพิ่มที่ตั้งรถของคุณ',
      step2Desc: 'แจ้งให้ผู้เช่าทราบว่าจะไปรับรถที่ไหน เพื่อเพิ่มการมองเห็นและทำให้การจองง่ายขึ้น',
      step2IconAlt: 'ไอคอนที่ตั้ง',
      step3Label: '3. ตั้งราคาและรายได้ของคุณ',
      step3Desc: 'ตัดสินใจว่าคุณต้องการรายได้เท่าไร และ HAUP จะช่วยคุณประเมินรายได้',
      step3IconAlt: 'ไอคอนราคา',
      additionalTitle: 'ขั้นตอนเพิ่มเติมเพื่อเริ่มมีรายได้',
      additionalStep1: 'อัปโหลดรูปภาพรถที่ชัดเจน',
      additionalStep2: 'อัปโหลดเอกสาร',
      skipButton: 'ข้ามไปก่อน',
      getStarted: 'เริ่มต้น →',
    },
    welcomeOverviewPro: {
      title: 'แชร์รถของคุณใน 3 ขั้นตอนหลักง่ายๆ เพื่อลิสต์บนแพลตฟอร์ม',
      step1Label: '1. บอกเราเกี่ยวกับรถของคุณ',
      step1Desc: 'เพิ่มรายละเอียด เช่น ยี่ห้อ รุ่น ปี และสี เพื่อช่วยให้ผู้เช่ารู้ว่าจะได้อะไร',
      step1IconAlt: 'ไอคอนข้อมูลรถ',
      step2Label: '2. ยืนยันบริการเช่ารถและราคา',
      step2Desc:
        'ตัดสินใจว่าคุณต้องการปล่อยเช่ารถของคุณอย่างไร และยืนยันราคาของ HAUP เพื่อเริ่มมีรายได้',
      step2IconAlt: 'ไอคอนราคา',
      step3Label: '3. นัดหมายการติดตั้งอุปกรณ์ IoT',
      step3Desc: 'เลือกวันและเวลาให้ช่างของเราติดตั้งอุปกรณ์ IoT ของ HAUP ที่ศูนย์ HAUP',
      step3IconAlt: 'ไอคอนอุปกรณ์ IoT',
      whatsNextLabel: 'ขั้นตอนถัดไป',
      requiredLabel: 'หลังจากคุณส่งข้อมูล HAUP จะช่วยคุณในเรื่อง',
      requiredStep1: 'ติดตั้งอุปกรณ์ IoT ให้เสร็จสมบูรณ์ในวันนัดหมาย',
      requiredStep2: 'จัดสรรที่จอดรถของคุณกับ HAUP',
      requiredStep3: 'เซ็นสัญญา',
      getStarted: 'เริ่มต้น →',
    },
    listing: {
      pageTitle: 'รายการของคุณบนแพลตฟอร์ม HAUP อยู่ที่นี่',
      tabVehicles: 'ยานพาหนะ',
      tabActivities: 'กิจกรรม',
      tabProperty: 'อสังหาริมทรัพย์',
      lineChat: 'แชทกับเรา',
      lineAdd: 'เพิ่มเราใน LINE',
      emptyTitle: 'คุณยังไม่ได้ลงรายการรถ!',
      emptyDesc: 'ลงรายการรถคันแรกของคุณและปลดล็อกโอกาสสร้างรายได้ใหม่วันนี้',
      sectionActionRequired: 'ต้องการให้แก้ไข',
      sectionIncomplete: 'ข้อมูลยังไม่ครบ',
      sectionPending: 'กำลังตรวจสอบ',
      sectionCompleted: 'ดำเนินการสำเร็จ',
      sectionPublished: 'กำลังปล่อยเช่า',
      sectionCarSubmits: 'รถที่ส่งผ่านลิงก์คำขอ',
      sectionUnqualified: 'ไม่ผ่านคุณสมบัติ',
      noData: 'ไม่มีข้อมูล',
      registerBtn: 'ลงทะเบียน',
      addModalTitle: 'คุณต้องการทำอะไร?',
      addModalDesc: 'กรุณาเลือกวิธีที่คุณต้องการลงรายการใน HAUP :',
      vehicleOption: 'รถยนต์',
      vehicleOptionDesc: 'ให้ผู้อื่นจองและขับรถของคุณ',
      activityOption: 'กิจกรรม',
      activityOptionDesc: 'ลงรายการกิจกรรมของคุณให้นักเดินทางจอง',
      propertyOption: 'อสังหาริมทรัพย์',
      propertyOptionDesc: 'ลงรายการอสังหาริมทรัพย์ของคุณให้ผู้เช่าเข้าพัก',
      vehicleTypeTitle: 'เลือกประเภทความเป็นเจ้าของ',
      vehicleTypeDesc: 'กรุณาระบุประเภทความเป็นเจ้าของ:',
      countryLabel: 'ประเทศที่รถของคุณอยู่',
      countryThailand: 'ไทย',
      countryIndonesia: 'อินโดนีเซีย',
      individualOwner: 'เจ้าของรถทั่วไป',
      individualOwnerDesc: 'สำหรับปล่อยเช่ารถรายคัน',
      rentalBusiness: 'ธุรกิจรถเช่า',
      rentalBusinessDesc: 'สำหรับธุรกิจรถเช่า',
      lineConnectTitle: 'เชื่อมต่อบัญชี LINE',
      lineConnectDesc:
        'เพื่อดำเนินการต่อ กรุณาเชื่อมต่อบัญชี LINE ของคุณเพื่อรับการแจ้งเตือนและการสนับสนุนสำหรับการส่งรถของคุณ',
      lineConnectBtn: 'เชื่อมต่อบัญชี LINE',
      statusIncomplete: 'ไม่สมบูรณ์',
      statusActionRequired: 'ต้องดำเนินการ',
      statusPending: 'รอดำเนินการ',
      statusSubmitted: 'ส่งแล้ว',
      statusCompleted: 'เสร็จสิ้น',
      statusVerified: 'ตรวจสอบแล้ว',
      statusPublished: 'เผยแพร่แล้ว',
      statusUnknown: 'ไม่ทราบสถานะ',
      lastEdited: 'แก้ไขล่าสุดเมื่อ',
      uploadDocuments: 'อัพโหลดเอกสาร',
      continueBtn: 'ดำเนินการต่อ',
      manageBtn: 'จัดการ',
      viewBtn: 'ดูรถ',
      carSubmitAccepted: 'ได้รับการยอมรับ',
      carSubmitRejected: 'ถูกปฏิเสธ',
      carSubmitPending: 'รอดำเนินการ',
      carSubmitSentOn: 'ส่งเมื่อ',
      carSubmitContinue: 'ดำเนินการต่อ',
      pullToRefresh: 'ดึงลงเพื่อรีเฟรช',
      releaseToRefresh: 'ปล่อยเพื่อรีเฟรช',
      refreshing: 'กำลังโหลด...',
      refreshComplete: 'รีเฟรชสำเร็จ',
      proIntro: {
        title: 'รับรายได้เพิ่มขึ้นกับ HAUP Pro',
        subtitle:
          'ก่อนลงรายการรถของคุณ มาดูกันว่าเจ้าของรถ Pro สร้างรายได้มากกว่าอย่างเห็นได้ชัด — โดยใช้ความพยายามน้อยกว่า',
        proLabel: 'Pro',
        proBadge: 'แพ็กเกจพรีเมียม',
        proBullet1:
          'ลงรายการบนแพลตฟอร์ม HAUP และเว็บไซต์พันธมิตรท่องเที่ยวของเรา — *Trip.com, Klook* ให้ผู้เช่าเห็นรถของคุณมากขึ้น',
        proBullet2: '*การจองยืนยันทันที* ไม่ต้องรอการอนุมัติจากคุณ',
        proBullet3: 'ยอดจองเพิ่มขึ้นสูงสุด *3 เท่า*',
        proBullet4:
          'ติดตามรถของคุณแบบ *เรียลไทม์* และรับประสบการณ์เช่ารถ *แบบไร้สัมผัสอย่างไร้รอยต่อ*',
        proBullet5: 'เลือกได้ระหว่าง *แผนแบ่งรายได้ 2 รูปแบบ*',
        learnMoreRevenuePlans: 'เรียนรู้เพิ่มเติมเกี่ยวกับแผนแบ่งรายได้',
        proNote: 'Pro ต้องติดตั้งอุปกรณ์ HAUP IoT เราจะแนะนำขั้นตอนให้คุณในขั้นตอนถัดไป',
        learnMorePro: 'เรียนรู้เพิ่มเติมเกี่ยวกับ Pro',
        starterLabel: 'Starter',
        starterBullet1: 'ลงรายการเฉพาะบนแพลตฟอร์มของเราให้ผู้เช่าค้นหา',
        starterBullet2: 'คุณตรวจสอบและยอมรับคำขอจองแต่ละรายการเอง',
        starterBullet3: 'ไม่ต้องติดตั้งอุปกรณ์ แต่ยอดจองน้อยกว่า',
        starterBullet4: 'จัดการการจองด้วยตนเองและนัดพบผู้เช่าเพื่อส่งมอบกุญแจ',
        starterBullet5: 'กำหนดรายได้เองและรับราคาที่คุณตั้งไว้สำหรับรถของคุณ',
        learnMoreStarter: 'เรียนรู้เพิ่มเติมเกี่ยวกับ Starter',
        continueWithProBtn: 'ดำเนินการต่อกับ Pro',
        continueWithStarterBtn: 'ดำเนินการต่อกับ Starter',
        earningsCalculator: {
          entryTitle: 'คำนวณรายได้ของคุณ',
          entrySubtitle: 'ประเมินรายได้ของคุณภายใน 10 วินาที',
          modalTitle: 'รถของคุณจะสร้างรายได้เท่าไหร่?',
          modalSubtitle: 'กรอกข้อมูลรถของคุณเพื่อดูความแตกต่างระหว่าง Pro และ Starter',
          brandLabel: 'ยี่ห้อ',
          brandPlaceholder: 'เลือกยี่ห้อรถของคุณ',
          modelLabel: 'รุ่น',
          modelPlaceholder: 'เลือกรุ่นรถของคุณ',
          yearLabel: 'ปีรถ',
          yearPlaceholder: 'เลือกปีรถของคุณ',
          calculateBtn: 'คำนวณรายได้ของฉัน',
          resultsTitle: 'รายได้โดยประมาณของคุณ',
          resultsSubtitle:
            'ประมาณการจากอัตราการใช้งานเฉลี่ยบนแพลตฟอร์ม รายได้จริงอาจแตกต่างกันไปตามทำเล ฤดูกาล และความต้องการ',
          perDayRateLabel: 'ราคาต่อวัน',
          perDayRateNote: 'ขึ้นอยู่กับรุ่นและปีรถ',
          perMonthRateLabel: 'ราคาต่อเดือน',
          perMonthRateNote: 'ราคาเช่ารายเดือนแบบระยะยาว (ราคาพิเศษ)',
          standardPricingNote:
            'อ้างอิงจากราคามาตรฐานของ HAUP คุณสามารถตั้งราคาของคุณเองได้ในภายหลัง',
          starterLabel: 'Starter',
          proLabel: 'Verified Pro',
          utilisationRateLabel: 'อัตราการใช้งาน',
          estRentalDaysLabel: 'จำนวนวันเช่าโดยประมาณต่อเดือน',
          estIncomeLabel: 'รายได้โดยประมาณต่อเดือน',
          listedOnlyOnLabel: 'ลงรายการเฉพาะบน',
          listedOnLabel: 'ลงรายการเพิ่มเติมบน',
          proUtilisationBannerTitle: 'โฮสต์ Pro มีอัตราการใช้งานสูงถึง 80%',
          proUtilisationBannerSubtitle:
            'การลงรายการบน Trip.com และ Klook พร้อมการยืนยันการจองทันที ช่วยดึงดูดผู้เช่าได้มากขึ้น',
          disclaimer:
            'เป็นเพียงการประมาณการจากรูปแบบการจองทั่วไปของรถที่คล้ายกันบนแพลตฟอร์มของเรา รายได้จริงอาจแตกต่างกันไปตามทำเล สภาพรถ และความต้องการ',
          continueWithProBtn: 'ดำเนินการต่อกับ Pro',
          backToOverviewBtn: 'กลับไปหน้าภาพรวม',
          notFoundError: 'ไม่พบข้อมูลราคาสำหรับรถคันนี้',
        },
        planDetails: {
          backBtn: 'กลับ',
          featureListLabel: 'รายการฟีเจอร์',
          starterColLabel: 'STARTER',
          proColLabel: 'VERIFIED-PRO',
          featureRows: [
            { label: 'อุปกรณ์เสริม', starter: '✕', pro: 'HAUP IoT GPS' },
            { label: 'รูปแบบการเช่า', starter: 'รายวัน', pro: 'รายชั่วโมง / รายวัน' },
            {
              label: 'การจองล่วงหน้าขั้นต่ำ',
              starter: 'ล่วงหน้า 24 ชั่วโมง',
              pro: 'ล่วงหน้า 15 นาที',
            },
            { label: 'การปลดล็อกรถ', starter: 'กุญแจรถ', pro: 'ปลดล็อกผ่านแอป' },
            {
              label: 'ประกันภัยเชิงพาณิชย์ (จัดหาโดยพาร์ทเนอร์)',
              starter: 'ไม่บังคับ',
              pro: 'บังคับ',
            },
            { label: 'การบำรุงรักษารถ', starter: 'เจ้าของรถ', pro: 'HAUP' },
            { label: 'รูปแบบรายได้', starter: 'รายได้สุทธิ', pro: 'แบ่งรายได้' },
            {
              label: 'เงินประกันสัญญาต่อคัน',
              starter: '500 บาท',
              pro: '2,000 บาท',
            },
            { label: 'ค่าติดตั้งอุปกรณ์', starter: '✕', pro: '1,070 บาทต่อคัน' },
            {
              label: 'ค่าบริการอุปกรณ์รายเดือน',
              starter: '✕',
              pro: '490 บาทต่อคันต่อเดือน',
            },
          ],
          pro: {
            title: 'รายละเอียดแพ็กเกจ Pro',
            bullets: [
              '*ไม่ต้อง* พบผู้เช่า',
              'ต้องจอดรถที่ *สถานี HAUP*',
              'ผู้เช่าสามารถจองได้ตลอดเวลา โดย *แจ้งล่วงหน้าเพียง 15 นาที*',
              'เปิดให้บริการ *ขั้นต่ำ 30 นาที*',
              'เลือกได้จาก *แผนแบ่งรายได้ 2 รูปแบบ* ที่เหมาะกับวิธีบริหารรถของคุณ',
              '*ต้องมีหรือซื้อ* ประกันภัย',
            ],
            linkLabel: 'เรียนรู้เพิ่มเติมเกี่ยวกับแผนแบ่งรายได้',
            linkAfterIndex: 4,
          },
          starter: {
            title: 'รายละเอียดแพ็กเกจ Starter',
            bullets: [
              '*นัดพบผู้เช่า* เพื่อส่งมอบกุญแจ',
              '*ไม่ต้อง* จอดรถที่สถานี HAUP',
              'ผู้เช่าสามารถจองได้โดย *แจ้งล่วงหน้า 24 ชั่วโมง*',
              'เปิดให้บริการ *เฉพาะแบบรายวันขึ้นไป*',
              'กำหนด *รายได้เองและรับราคาที่คุณตั้งไว้* สำหรับรถของคุณ',
            ],
            linkLabel: 'เรียนรู้เพิ่มเติมเกี่ยวกับรายได้สุทธิ',
            linkAfterIndex: 4,
          },
        },
        revenuePlans: {
          title: 'เปรียบเทียบแผนแบ่งรายได้',
          subtitle:
            'เปรียบเทียบสิทธิประโยชน์และหน้าที่ของแต่ละแผน เพื่อเลือกแผนที่เหมาะกับคุณที่สุด',
          plan5545Title: 'เจ้าของ 55%, HAUP 45%',
          plan5545Subtitle: 'ไม่รวมค่าแอร์ไทม์รายเดือน',
          plan5545Desc:
            'HAUP ดูแลการดำเนินงานและบำรุงรักษารถของคุณ แต่ค่าแอร์ไทม์ 490 บาท/เดือน ไม่รวมอยู่ในแผนนี้ และจะถูกหักแยกต่างหาก',
          plan5050Title: 'เจ้าของ 50%, HAUP 50%',
          plan5050Subtitle: 'รวมค่าแอร์ไทม์รายเดือน',
          plan5050Desc: 'HAUP ดูแลการดำเนินงานและบำรุงรักษารถของคุณ โดยรวมค่าแอร์ไทม์รายเดือนแล้ว',
          featuresLabel: 'ฟีเจอร์',
          col5050Label: '50/50',
          col5545Label: '55/45',
          rows: [
            { label: 'ค่าแอร์ไทม์รายเดือน', col1Check: true, col2Check: false },
            { label: 'ค่าที่จอดรถรายเดือน', col1Check: true, col2Check: true },
            { label: 'การบำรุงรักษารถ', col1Check: true, col2Check: true },
            { label: 'การประสานงานซ่อมบำรุง', col1Check: true, col2Check: true },
          ],
        },
        netRevenue: {
          title: 'รายได้สุทธิ',
          description:
            'รายได้สุทธิคือจำนวนเงินสุดท้ายที่คุณจะได้รับจากการเช่าแต่ละครั้งที่สำเร็จ โดยมีการหักเพียงภาษีหัก ณ ที่จ่าย 3% ตามกฎหมายเท่านั้น ไม่มีค่าธรรมเนียมแพลตฟอร์ม ค่าคอมมิชชั่น หรือค่าใช้จ่ายแอบแฝงอื่นใดถูกหักจากรายได้ของคุณ',
          exampleLabel: 'ตัวอย่าง',
          exampleIntro: 'หากคุณตั้งรายได้ที่ 1,000 บาท:',
          bullet1: 'รายได้ที่ตั้งไว้: 1,000 บาท',
          bullet2: 'ภาษีหัก ณ ที่จ่าย 3%: 30 บาท',
          bullet3: 'รายได้สุทธิที่ได้รับ: 970 บาท',
          noteText:
            'HAUP อาจปรับราคาสุดท้ายที่ผู้เช่าเห็นตามความต้องการของตลาดและโปรโมชั่น แต่รายได้ของคุณจะยึดตามจำนวนที่คุณตั้งไว้เสมอ',
        },
        iotDevice: {
          title: 'ติดตั้งอุปกรณ์ HAUP IoT',
          subtitle:
            'อุปกรณ์ขนาดเล็กชิ้นนี้คือสิ่งที่ทำให้การจองทันทีและการปกป้องรถแบบเรียลไทม์เป็นไปได้',
          deviceTitle: 'HAUP IOT - GPS',
          deviceDesc:
            'อุปกรณ์อัจฉริยะขนาดเล็กที่ติดตั้งในรถของคุณ ช่วยให้เข้าถึงรถจากระยะไกล ตรวจสอบสถานะรถ และปล่อยเช่าแบบไร้การสัมผัสได้',
          compatibleTitle: 'รองรับรถยนต์หลากหลายยี่ห้อยอดนิยม',
          moreLabel: '+เพิ่มเติม',
          whyTitle: 'ทำไมต้องติดตั้งอุปกรณ์ HAUP IoT?',
          features: [
            { title: 'ตำแหน่งเรียลไทม์', desc: 'ติดตามตำแหน่งรถของคุณแบบเรียลไทม์' },
            {
              title: 'ล็อก/ปลดล็อกผ่านแอปมือถือ',
              desc: 'ส่งมอบรถแบบไร้การสัมผัสด้วยการล็อก/ปลดล็อกจากระยะไกล',
            },
            { title: 'สถานะรถ', desc: 'ดูสถานะรถของคุณจากระยะไกล' },
            { title: 'การแจ้งเตือนอัจฉริยะ', desc: 'รับการแจ้งเตือนเหตุการณ์สำคัญของรถ' },
            {
              title: 'การตรวจสอบและแจ้งเตือนรถ',
              desc: 'รับทราบข้อมูลผ่านการแจ้งเตือนสำคัญของรถอยู่เสมอ',
            },
          ],
          installationFeeLabel: 'ค่าติดตั้งทั้งหมด',
          installationFeeValue: '1,070 บาท',
          installationFeeNote: '(รวม VAT)',
          dueTodayLabel: 'ยอดที่ต้องชำระวันนี้',
          dueTodayValue: '99.00 บาท',
          dueTodayNote: '(ไม่สามารถขอคืนเงินได้)',
          installmentText:
            'ยอดคงเหลือ *971 บาท* จะถูกแบ่งชำระเป็น *10 งวดต่อเดือน* จาก *กระเป๋าเงินรายได้* ของคุณ หรือช่องทางการชำระเงินที่คุณต้องการ',
          payBtn: 'ชำระ 99 บาท เพื่อดำเนินการต่อกับ Pro',
          goBackBtn: 'ย้อนกลับ',
        },
        takeALook: {
          title: 'ลองพิจารณาอีกครั้งก่อนตัดสินใจ',
          subtitle: 'ไม่กดดันเลย — นี่คือความแตกต่างที่ชัดเจน เปรียบเทียบกันแบบเห็นภาพ',
          featureLabel: 'ฟีเจอร์',
          proLabel: 'PRO',
          starterLabel: 'STARTER',
          rows: [
            { label: 'ลงรายการบน Trip.com และ Klook', proCheck: true, starterCheck: false },
            { label: 'การจองยืนยันทันที', proCheck: true, starterCheck: false },
            { label: 'อันดับการค้นหาที่ได้รับความสำคัญ', proCheck: true, starterCheck: false },
            { label: 'ติดตามตำแหน่งแบบเรียลไทม์ (GPS)', proCheck: true, starterCheck: false },
            { label: 'การปกป้องรถขั้นสูง', proCheck: true, starterCheck: false },
            { label: 'ลงรายการบนแพลตฟอร์ม HAUP', proCheck: true, starterCheck: true },
            { label: 'การจัดการการจองพื้นฐาน', proCheck: true, starterCheck: true },
          ],
          note: 'Pro เป็นตัวเลือกเสริม และคุณสามารถเปลี่ยนมาใช้ภายหลังได้ทุกเมื่อจากการตั้งค่ารถของคุณ Starter ก็ทำให้รถของคุณถูกลงรายการและสร้างรายได้ได้เช่นกัน — Pro เพียงแค่เปิดโอกาสให้ผู้เช่าพบรถของคุณได้มากขึ้น',
          switchToProBtn: 'เปลี่ยนไปใช้ Pro',
          continueStarterBtn: 'ดำเนินการต่อด้วย Starter',
        },
        payment: {
          title: 'ชำระเงินให้เสร็จสมบูรณ์',
          subtitle: 'ค่าธรรมเนียมครั้งเดียวสำหรับอุปกรณ์ HAUP และการติดตั้ง',
          infoNote:
            'หลังจากส่งข้อมูลรถของคุณเสร็จสิ้น คุณจะสามารถนัดหมายการติดตั้งอุปกรณ์ HAUP IoT ได้',
          paymentDetailsLabel: 'รายละเอียดการชำระเงิน',
          depositLabel: 'มัดจำค่าติดตั้ง',
          processingFeeLabel: 'ค่าธรรมเนียมการชำระเงิน',
          processingFeeNote: '{percent}% ของค่าติดตั้ง',
          totalLabel: 'ยอดชำระวันนี้',
          selectMethodLabel: 'วิธีการชำระเงิน',
          cardLabel: 'บัตรเดบิต/เครดิต',
          scbPromptPayLabel: 'SCB พร้อมเพย์',
          alipayLabel: 'Alipay',
          wechatPayLabel: 'WeChat Pay',
          qrPromptPayLabel: 'พร้อมเพย์',
          cardNumberLabel: 'หมายเลขบัตรเดบิต/เครดิต',
          cardNumberPlaceholder: '1234 5678 9012 3456',
          cardHolderLabel: 'ชื่อผู้ถือบัตรเดบิต/เครดิต',
          cardHolderPlaceholder: 'JOHN DOE',
          expiryLabel: 'วันหมดอายุ',
          cvvLabel: 'CVV/CVC',
          payBtnPrefix: 'ชำระ THB',
          payBtnSuffix: 'เพื่อส่งข้อมูลรถพร้อมแพ็กเกจ Pro',
          processingBtn: 'กำลังดำเนินการชำระเงิน...',
          depositBannerTitle: 'คุณมีค่ามัดจำติดตั้งที่ชำระแล้ว',
          depositBannerDesc:
            'ค่ามัดจำ 99 บาท ของคุณพร้อมใช้งาน ลงประกาศรถของคุณกับ Pro ได้เลย โดยไม่ต้องชำระเงินอีกครั้ง',
          depositBannerCta: 'ลงประกาศรถกับ Pro',
          alreadyPaidTitle: 'ชำระค่ามัดจำแล้ว',
          alreadyPaidDesc:
            'คุณได้ชำระค่ามัดจำติดตั้ง 99 บาท ไว้แล้ว เราจะนำค่ามัดจำนี้ไปใช้กับรถคันที่คุณกำลังลงทะเบียน โดยไม่มีการเรียกเก็บเงินซ้ำ',
          alreadyPaidContinue: 'ดำเนินการต่อ',
          processingModalTitle: 'กำลังดำเนินการชำระเงิน',
          processingModalDesc: 'กรุณารอสักครู่ อย่าปิดหรือรีเฟรชหน้านี้',
          goBackBtn: 'ย้อนกลับ',
          qrModalTitle: 'ชำระเงินด้วย {method}',
          qrModalSubtitle: 'สแกน QR โค้ดนี้ด้วยแอปธนาคารบนมือถือของคุณเพื่อชำระเงิน',
          qrWaitingText: 'กำลังรอการยืนยันการชำระเงิน...',
          qrNote: 'กรุณาอย่าปิดหน้าต่างนี้จนกว่าการชำระเงินจะได้รับการยืนยัน',
        },
      },
    },
    finish: {
      loadingText: 'กำลังโหลด...',
      submittingTitle: 'กำลังส่งข้อมูลรถของคุณ',
      submittingDesc: 'กรุณารอสักครู่ อย่ารีเฟรชหน้านี้',
      noVehicleData: 'ไม่พบข้อมูลรถ',
      requestBookingBadge: 'จองรถ',
      instantBookingBadge: 'ยืนยันทันที',
      meetWithOwner: 'นัดรับกับเจ้าของรถ',
      appUnlock: 'ปลดล็อกผ่านแอป',
      seatsLabel: 'ที่นั่ง',
      successTitle: 'สำเร็จ! รถของคุณได้รับการลงทะเบียนบนแพลตฟอร์มของเราแล้ว',
      viewCarBtn: 'ดูรถของคุณ',
      lineTitle: 'ติดต่อกับเราผ่าน LINE',
      lineDesc:
        'ก่อนดำเนินการขั้นตอนที่เหลือ กรุณาติดต่อกับเราผ่าน LINE ทีมงานของเราจะแนะนำคุณตลอดกระบวนการและช่วยให้คุณติดตามคำขอของคุณโดยตรง',
      lineChat: 'แชทกับเรา',
      stepsTitle: 'ขั้นตอนที่เหลือเพื่อให้เสร็จสมบูรณ์',
      step1Title: 'การส่งข้อมูลเสร็จสมบูรณ์',
      step2Title: 'รถของคุณได้รับการลงทะเบียนบนแพลตฟอร์ม',
      step3Title: 'ดาวน์โหลดแอป',
      step3Desc: 'คุณต้องดาวน์โหลดแอปของเราเพื่อจัดการรายการรถ ตอบคำขอ และติดตามรายได้',
      step3ManageBtn: 'จัดการรถของคุณ',
      step3DownloadBtn: 'ดาวน์โหลดแอป',
      incompleteBadge: 'ไม่สมบูรณ์',
      doneBtn: 'เสร็จสิ้น',
      manageBtn: 'จัดการรถของคุณ',
      proAllSetTitle: 'เสร็จเรียบร้อย!',
      proAllSetSubtitle:
        'รถของคุณถูกส่งเรียบร้อยแล้ว และนัดหมายการติดตั้งอุปกรณ์ IoT ของคุณเรียบร้อยแล้ว',
      proIotScheduledTitle: 'กำหนดการติดตั้งอุปกรณ์ IoT',
      proStartEarningTitle: 'เพื่อเริ่มมีรายได้ กรุณาทำขั้นตอนที่จำเป็นเหล่านี้ให้เสร็จ',
      proStartEarningDesc: 'คุณต้องทำขั้นตอนที่เหลือให้เสร็จเพื่อเริ่มมีรายได้จากการจอง',
      proStepSubmitCarInfo: 'ส่งข้อมูลรถ',
      proStepSetPricing: 'ตั้งราคา',
      proStepScheduleIot: 'นัดหมายติดตั้งอุปกรณ์ IoT',
      proStepDownloadApp: 'ดาวน์โหลดแอป',
      proStepUploadImagesDocs: 'อัปโหลดรูปภาพและเอกสาร',
      proStepSignContract: 'เซ็นสัญญา',
      proStepCompleteIot: 'ติดตั้งอุปกรณ์ IoT ให้เสร็จสมบูรณ์',
      proStepSelectParking: 'เลือกที่จอดรถกับ HAUP',
      proManageBtn: 'จัดการรถของคุณ',
      proFinishBtn: 'เสร็จสิ้น',
    },
    paymentCallback: {
      processingTitle: 'กำลังตรวจสอบการชำระเงินของคุณ',
      processingDesc: 'กรุณารอสักครู่ในขณะที่เรายืนยันการชำระเงินของคุณ',
      successTitle: 'ชำระมัดจำค่าติดตั้งสำเร็จ',
      successDesc: 'เราได้รับมัดจำค่าติดตั้งของคุณเรียบร้อยแล้ว',
      refIdLabel: 'หมายเลขอ้างอิง',
      whatsNextLabel: 'ขั้นตอนถัดไป',
      step1: 'ส่งข้อมูลรถของคุณให้ครบเพื่อลงรายการ',
      step2: 'นัดหมายการติดตั้งอุปกรณ์ IoT ของคุณ',
      failedTitle: 'การชำระเงินไม่สำเร็จ',
      failedDesc: 'เราไม่สามารถยืนยันการชำระเงินของคุณได้ กรุณาลองใหม่อีกครั้งจากแท็บเดิม',
      continueBtn: 'ดำเนินการต่อ',
      closeBtn: 'ปิดหน้าต่างนี้',
    },
    proPricing: {
      revenuePlanTitle: 'เลือกแผนแบ่งรายได้ของคุณ',
      plan5050Label: 'เจ้าของ 50%, HAUP 50%',
      plan5545Label: 'เจ้าของ 55%, HAUP 45%',
      plan5050Tagline: 'ครบวงจร ไร้กังวล',
      plan5545Tagline: 'ส่วนแบ่งสูงกว่า ยืดหยุ่นกว่า',
      airtimeIncluded: 'รวมค่าแอร์ไทม์รายเดือน',
      airtimeNotIncluded: 'ไม่รวมค่าแอร์ไทม์รายเดือน',
      maintenanceIncluded: 'รวมการบำรุงรักษาและค่าที่จอดรถ',
      operationsManaged: 'การดำเนินงานรถดูแลโดย HAUP',
      idealForLabel: 'เหมาะสำหรับ :',
      plan5050IdealFor: 'เจ้าของที่ต้องการแผนแบบครบวงจร มีค่าใช้จ่ายที่ต้องจัดการน้อยลง',
      plan5545IdealFor:
        'เจ้าของที่ต้องการส่วนแบ่งรายได้สูงกว่า และไม่ติดขัดที่จะจ่ายค่าแอร์ไทม์รายเดือนแยกต่างหาก',
      learnMorePlan: 'เรียนรู้เพิ่มเติมเกี่ยวกับแผนนี้',
      comparePlans: 'เปรียบเทียบแผนแบ่งรายได้',
      whatsIncludedLabel: 'มีอะไรรวมอยู่บ้าง?',
      plan5050ModalDesc: 'ครบวงจร ไร้กังวล',
      plan5545ModalDesc: 'รายได้สูงกว่า พร้อมความยืดหยุ่นมากขึ้น',
      plan5050Benefits: [
        'รวมค่าแอร์ไทม์รายเดือน',
        'รวมค่าที่จอดรถรายเดือน',
        'ลงรายการรถบน HAUP และแพลตฟอร์มพันธมิตร',
        'จองทันทีและรับรถแบบไร้การสัมผัส',
        'การบำรุงรักษาและการบริการรถดูแลโดย HAUP',
        'ติดตามรถแบบเรียลไทม์ผ่าน HAUP IoT',
      ],
      plan5545Benefits: [
        'ไม่รวมค่าแอร์ไทม์รายเดือน',
        'รวมค่าที่จอดรถรายเดือน',
        'ลงรายการรถบน HAUP และแพลตฟอร์มพันธมิตร',
        'จองทันทีและรับรถแบบไร้การสัมผัส',
        'การบำรุงรักษาและการบริการรถดูแลโดย HAUP',
        'ติดตามรถแบบเรียลไทม์ผ่าน HAUP IoT',
      ],
      insuranceQuestion: 'คุณมีประกันภัยสำหรับรถของคุณหรือไม่?',
      insuranceYes: 'มี',
      insuranceNo: 'ไม่มี',
      insuranceTypeQuestion: 'คุณมีประกันภัยประเภทใด?',
      insurancePersonal: 'ประกันภัยส่วนบุคคล',
      insuranceCommercial: 'ประกันภัยเชิงพาณิชย์',
      insurancePackageTitle: 'เลือกแพ็กเกจประกันภัย',
      insurancePackageMostPick: 'เลือกมากที่สุด',
      insurancePackageDesc: 'ประกันภัยเชิงพาณิชย์ระยะเวลา',
      monthsLabel: 'เดือน',
      standardPriceSectionTitle: 'ราคาค่าเช่ามาตรฐาน',
    },
    proReview: {
      title: 'คุณทำขั้นตอนหลักเสร็จแล้ว!',
      subtitle: 'ตรวจสอบรายละเอียดของคุณก่อนส่งรถเข้าสู่แพลตฟอร์ม',
      revenueShareLabel: 'การแบ่งรายได้',
      dailyLabel: 'เช่ารายวัน',
      weeklyLabel: 'เช่ารายสัปดาห์',
      monthlyLabel: 'เช่ารายเดือน',
      yearlyLabel: 'เช่ารายปี',
      perDay: 'บาท/วัน',
      perWeek: 'บาท/สัปดาห์',
      perMonth: 'บาท/เดือน',
      perYear: 'บาท/ปี',
      iotScheduleTitle: 'กำหนดการติดตั้งอุปกรณ์ IoT',
      submitBtn: 'ยืนยันและส่งข้อมูลเลย',
    },
    proAppointment: {
      title: 'นัดหมายการติดตั้งอุปกรณ์ IoT ของคุณ',
      subtitle:
        'เลือกวันและเวลาที่สะดวกสำหรับการติดตั้งอุปกรณ์ HAUP IoT ช่างผู้ได้รับการรับรองของเราจะติดตั้งและเปิดใช้งานอุปกรณ์ เพื่อให้คุณได้รับสิทธิประโยชน์ทั้งหมดของ Pro Listing',
      selectDateTimeLabel: 'เลือกวันและเวลา',
      selectTimeLabel: 'เลือกเวลา',
      garageName: 'HAUP Garage',
      garageAddress: '12 ถนนพญาไท แขวงทุ่งพญาไท เขตราชเทวี กรุงเทพมหานคร 104000',
      directionsLink: 'ดูเส้นทางบน Google Maps',
      durationNote:
        'การติดตั้งใช้เวลาประมาณ 30–45 นาที กรุณาเตรียมรถและกุญแจให้พร้อมในเวลาที่นัดหมาย',
      confirmBtn: 'ยืนยันและส่งข้อมูล',
      goBackBtn: 'ย้อนกลับ',
      exitBtn: 'ออก',
      welcomeModal: {
        stepNumber: 'ขั้นตอนที่ 3',
        title: 'นัดหมายการติดตั้งอุปกรณ์ IoT',
        description:
          'เลือกวันและเวลาที่สะดวกสำหรับการติดตั้งอุปกรณ์ HAUP IoT ของคุณ เมื่อติดตั้งแล้ว คุณจะปลดล็อกฟีเจอร์ Pro เช่น การจองแบบยืนยันทันที การเช่าแบบไร้สัมผัส และการติดตามรถแบบเรียลไทม์ เพื่อช่วยให้คุณจัดการรถของคุณได้ง่ายขึ้น',
        imageAlt: 'ไอคอนนัดหมายติดตั้ง',
        nextButton: 'ถัดไป',
        backButton: 'กลับ',
      },
    },
  },

  EN: {
    nav: {
      saveAndExit: 'Save & Exit',
      exit: 'Exit',
      chatWithUs: 'Chat with us',
      chatOnline: 'Chat online',
      langToggle: 'TH',
    },
    stepNames: {
      info: 'What type of car do you want to list?',
      proInfo: 'Tell us about your car',
      parking: 'Add parking location',
      earn: 'Set rental pricing',
      photo: 'Car photos',
      document: 'Documents',
      review: 'Review your details',
      appointment: 'Schedule IoT installation',
    },
    dialogs: {
      closeNew: {
        title: 'Do you want to close this page?',
        content:
          'Your data will not be saved after closing (it will be saved when you proceed to the next step).',
        ok: 'Yes',
        cancel: 'No',
      },
      closeSaved: {
        title: 'Do you want to close this page?',
        content: 'Your data will be saved. You can come back and continue later.',
        ok: 'Save & Close',
        cancel: 'No',
      },
    },
    required: 'This field is required',
    step1: {
      pageTitle: 'What type of car do you want to list?',
      pageSubtitle: 'Vehicles must be no more than 10 years old from the registration date.',
      vehicleBrand: 'Car brand',
      vehicleModel: 'Car model',
      vehicleYear: 'Registration year',
      licensePlate: 'License plate',
      province: 'Province',
      vehicleColor: 'Car color',
      vehicleColorNote:
        'Please select the vehicle color exactly as stated in the vehicle registration book.',
      optional: 'Add more vehicle details (optional)',
      transmission: 'Transmission',
      keyType: 'Engine start type',
      keyTypeKey: 'Key',
      keyTypePush: 'Push button',
      fuelType: 'Fuel type',
      mileage: 'Mileage',
      taxExpireDate: 'Tax expiry date',
      vinNo: 'Chassis number',
      back: 'Back',
      next: 'Next',
      licensePlateFormat: 'Invalid license plate format',
      loading: 'Loading...',
      seeMore: 'See more',
      showLess: 'Show less',
      kmUnit: 'km.',
      transmissionAuto: 'Automatic',
      transmissionManual: 'Manual',
      duplicatePlateExists: 'License plate already exists, registered with email',
      duplicatePlateCheckFailed: 'Could not verify this license plate. Please try again.',
      brandModalTitle: 'Select car brand',
      brandSearchPlaceholder: 'Search car brand...',
      brandNoData: 'No car brands available',
      brandNoResult: 'No car brands found',
      modelModalTitle: 'Select car model',
      modelSearchPlaceholder: 'Search car model...',
      modelNoData: 'No car models available',
      modelNoResult: 'No car models found',
      modelLoading: 'Loading car models...',
      subModelModalTitle: 'Select submodel',
      welcomeModal: {
        stepNumber: 'Step 1',
        title: 'Tell us about your car',
        description:
          'You will need to fill in basic details about your car, including the brand, model, year, and location. You can also add key features such as fuel type, transmission, or special functions. This helps renters know what they are booking and where to pick up the car.',
        proDescription:
          'You will need to fill in basic details about your car, including the brand, model, year, and colour. You can also add key features such as fuel type, transmission, or special functions. This helps renters know what they are booking.',
        imageAlt: 'Car illustration',
        backButton: 'Back',
        nextButton: 'Next',
      },
    },
    step2: {
      confirmOk: 'Confirm',
      confirmCancel: 'Cancel',
      selectedPoint: 'Selected pickup point',
      searchingSpot: 'Searching for parking spots',
      back: 'Back',
      next: 'Next',
      selectParking: 'Select parking',
      parkingModal: {
        stepNumber: 'Step 2',
        title: 'Add your car location',
        description:
          'You need to specify where your car is regularly parked, such as your home, condo, or a public parking lot. This location helps renters know where to pick up and return the car. Providing an accurate location improves trust, increases booking chances, and makes the handover process smoother.',
        imageAlt: 'Car location illustration',
        nextButton: 'Next',
        backButton: 'Back',
      },
    },
    step3: {
      loadingPrice: 'Loading pricing data...',
      submitting: 'Submitting your data...',
      bannerTitle: 'Earn more by offering long-term car rental!',
      bannerText:
        'Add rental options — simply enable long-term rental to create a steady ongoing income stream.',
      offerRentalsTitle: 'Rental options',
      offerRentalsQuestion: 'Would you like to offer additional rental options?',
      shortTermDefault: 'Short-term rental (default)',
      longTerm: 'Long-term rental',
      netRevenueTitle: 'Net Revenue',
      netRevenueDesc:
        'Net Revenue is the net income you as the car owner will receive after only a 3% withholding tax deduction.',
      pricingUnavailableTitle: 'Suggested price unavailable',
      pricingUnavailableDesc:
        'Pricing data for this vehicle is not yet available in our system. To ensure accurate and competitive rates, please contact us for manual pricing support.',
      setPriceTitle: 'Set net revenue price',
      enableHaupSuggestion: 'Enable HAUP price suggestion',
      perDay: 'Daily',
      perWeek: 'Weekly',
      perMonth: 'Monthly',
      perYear: 'Yearly',
      maxRentalDuration: 'Maximum rental duration',
      priceRangeNote: 'The price set must be within -30% to +30% of the standard rate.',
      priceNetNote:
        'The price you set here reflects your net income after service fees are deducted, so it may differ from the price shown to renters in the HAUP app.',
      standardPriceLink: 'HAUP standard rental rates',
      longTermPriceTitle: 'Price for long-term rental',
      depositTitle: 'Do you want to collect a security deposit from renters?',
      depositNote: 'Attract more bookings by offering a no-deposit option to renters.',
      depositYes: 'Yes, collect a deposit for my car',
      depositNo: 'No deposit (recommended)',
      depositAmount: 'Deposit amount',
      depositSuggested: 'Suggested for vehicle size',
      proTitle: 'Interested in upgrading to a Pro package later?',
      proText: 'Would you like to switch to a Pro package after joining?',
      proLink: 'View Pro package details',
      consentText: 'Please read and accept the',
      consentLink: 'Terms and Conditions',
      back: 'Back',
      save: 'Save',
      continueBtn: 'Continue',
      priceError: 'Please enter a price',
      priceExceedDailyError: 'Price cannot exceed the daily rate',
      skipAndSubmit: 'Skip & Submit',
      continueNext: 'Continue',
      completedTitle: 'You have completed the main steps!',
      completedText:
        'You have completed all the required steps. Your car is ready and waiting for bookings.',
      step1Done: 'Tell us about your car',
      step2Done: 'Add your car location',
      step3Done: 'Set pricing and income',
      additionalStepsTitle: 'Complete these steps anytime',
      additionalStepsNote:
        'You can skip for now, but completing them will improve your listing visibility and credibility.',
      step4Title: 'Show your car in its best light',
      step4Note: 'Upload clear photos — both interior and exterior — to attract renters.',
      step5Title: 'Upload documents',
      step5Note: 'Upload the required documents to verify your car and build renter confidence.',
      stdPriceModalTitle: 'HAUP suggested rates',
      stdPriceModalDesc: 'The table below shows average rates set by owners of',
      perDayLabel: 'Daily',
      perWeekLabel: 'Weekly',
      perMonthLabel: 'Monthly',
      perYearLabel: 'Yearly',
      perDayUnit: 'per day',
      perWeekUnit: 'per week',
      perMonthUnit: 'per month',
      totalLabel: 'Total',
      daysLabel: 'days',
      noData: 'No data',
      closeButton: 'Close',
      proModalTitle: 'Pro package details',
      proModalDesc: 'Pro Package fee',
      proPackageLabel: 'Pro Package',
      proPackageNow: 'Now',
      proYourShare: 'Your earnings',
      proPlatformFee: 'Platform service fee',
      proBenefitsTitle: 'Pro package benefits',
      proBenefits: [
        'Includes GPS',
        'Includes IoT unlock device',
        'Hourly rental',
        'Instant booking',
        'Unlock car via Haup app',
        'Monthly or yearly insurance',
      ],
      tcTitle: 'Terms and Conditions',
      tcNotFound: 'No terms and conditions found',
      longTermInfoTitle: 'Long-term car rental',
      longTermInfoDesc:
        'Enable long-term rental services — for monthly or yearly car rentals — catering to business travellers or relocators who need a car for extended periods.',
      longTermBenefitsTitle: 'Benefits of offering long-term rental',
      longTermBenefit1: 'Earn steady income from long-term bookings',
      longTermBenefit2: 'Reduce idle time between rentals',
      longTermBenefit3: 'Attract corporate clients and long-term renters',
      earnModal: {
        stepNumber: 'Step 3',
        proStepNumber: 'Step 2',
        title: 'Set your pricing and earnings',
        description:
          'You will need to set rental rates and expected availability, helping you decide how much income you want from your car. HAUP will provide income estimates based on your rates and vehicle usage, so you can make informed decisions and maximise your earnings.',
        imageAlt: 'Pricing and income illustration',
        nextButton: 'Next',
        backButton: 'Back',
      },
      skipModal: {
        year: '1 Year',
        month9: '9 Months',
        month6: '6 Months',
        month3: '3 Months',
        month1: '1 Month',
      },
    },
    step4: {
      pageTitle: 'Your car photos',
      pageSubtitle: 'Great photos make your car more appealing. We recommend:',
      photoTip1: 'Take photos in 4:3 landscape ratio',
      photoTip2: 'Keep the car centred in the frame',
      photoTip3: 'Ensure the car is clearly visible',
      cardPreviewTitle: 'Your car card preview',
      noPhotos: 'You have not uploaded any photos yet',
      uploadTitle: 'Upload car photos',
      frontSide: 'Front angle',
      backSide: 'Rear angle',
      front: 'Front view',
      leftSide: 'Passenger side',
      rightSide: 'Driver side',
      back: 'Rear view',
      cabin: 'Interior photos (you can upload more than 1)',
      skipAndSubmit: 'Skip & Submit',
      submitting: 'Submitting...',
      loading: 'Loading...',
      backBtn: 'Back',
      next: 'Next',
    },
    step5: {
      pageTitle: 'Document upload',
      pageSubtitle: 'Please upload the following documents to complete your rental agreement.',
      idCard: 'Your ID card',
      q1: 'Is the car registered under a company name?',
      q2Company: 'Are you a director of that company?',
      q2Personal: 'Are you the registered owner of this car?',
      q3CompanyOwner: 'Is the bank account in the company name or a company director?',
      q3CompanyNonOwner: 'Is the bank account in the company name or the car lister?',
      q3PersonalOwner: 'Is the bank account in the same name as the car owner?',
      q3PersonalNonOwner: 'Is the bank account in the same name as the car owner or car lister?',
      yes: 'Yes',
      no: 'No',
      companyCert: 'Company registration certificate',
      companyAuthorize: 'Company power of attorney',
      vehicleAuthorize: 'Vehicle owner power of attorney',
      vehicleReg: 'Vehicle registration book',
      taxBadge: 'Vehicle tax badge',
      bankBook: 'Bank passbook',
      bankBookAlt: 'Bank account page',
      bankUsageAuth: 'Account owner consent document',
      authorizeTemplate: 'Power of attorney template',
      skipAndSubmit: 'Skip & Submit',
      submitting: 'Submitting your data...',
      loading: 'Loading...',
      back: 'Back',
      next: 'Next',
    },
    welcomeOverview: {
      title: 'List your car in 3 easy steps',
      step1Label: '1. Tell us about your car',
      step1Desc:
        'Add details like brand, model, year, and colour so renters know what they will get.',
      step1IconAlt: 'Car info icon',
      step2Label: '2. Add your car location',
      step2Desc: 'Let renters know where to pick up the car to boost visibility and ease bookings.',
      step2IconAlt: 'Location icon',
      step3Label: '3. Set your pricing and earnings',
      step3Desc: 'Decide how much income you want, and HAUP will help you estimate your earnings.',
      step3IconAlt: 'Pricing icon',
      additionalTitle: 'Optional steps to start earning',
      additionalStep1: 'Upload clear car photos',
      additionalStep2: 'Upload documents',
      skipButton: 'Skip for now',
      getStarted: 'Get started →',
    },
    welcomeOverviewPro: {
      title: 'Share your car in 3 simple main steps to be listed on platform',
      step1Label: '1. Tell us about your car',
      step1Desc:
        'Add details like brand, model, year, and color to help renters know what to expect.',
      step1IconAlt: 'Car info icon',
      step2Label: '2. Confirm your rental service and pricing',
      step2Desc:
        'Decide how do you want to rent your car and confirm HAUP pricing to start earnings.',
      step2IconAlt: 'Pricing icon',
      step3Label: '3. Schedule your IoT installation',
      step3Desc:
        'Pick a date and time for our technician to install your HAUP IoT device at the HAUP garage.',
      step3IconAlt: 'IoT device icon',
      whatsNextLabel: "What's next?",
      requiredLabel: 'After you submit, HAUP will help you with',
      requiredStep1: 'Complete the IoT installation at your appointment',
      requiredStep2: 'Assign your vehicle parking with HAUP',
      requiredStep3: 'Sign the contract',
      getStarted: 'Get Started →',
    },
    listing: {
      pageTitle: 'Your listings on the HAUP platform',
      tabVehicles: 'Vehicles',
      tabActivities: 'Activities',
      tabProperty: 'Property',
      lineChat: 'Chat with us',
      lineAdd: 'Add us on LINE',
      emptyTitle: "You haven't listed a car yet!",
      emptyDesc: 'List your first car and unlock a new income opportunity today.',
      sectionActionRequired: 'Action required',
      sectionIncomplete: 'Incomplete',
      sectionPending: 'Under review',
      sectionCompleted: 'Completed',
      sectionPublished: 'Active rental',
      sectionCarSubmits: 'Cars submitted via request link',
      sectionUnqualified: 'Not qualified',
      noData: 'No data',
      registerBtn: 'Register',
      addModalTitle: 'What would you like to do?',
      addModalDesc: 'Please select how you want to list on HAUP:',
      vehicleOption: 'Vehicle',
      vehicleOptionDesc: 'Let others book and drive your car',
      activityOption: 'Activity',
      activityOptionDesc: 'List your activity for travellers to book',
      propertyOption: 'Property',
      propertyOptionDesc: 'List your property for guests to stay',
      vehicleTypeTitle: 'Select ownership type',
      vehicleTypeDesc: 'Please specify your ownership type:',
      countryLabel: 'Country where your car is located',
      countryThailand: 'Thailand',
      countryIndonesia: 'Indonesia',
      individualOwner: 'Individual car owner',
      individualOwnerDesc: 'For renting out a single car',
      rentalBusiness: 'Rental business',
      rentalBusinessDesc: 'For car rental businesses',
      lineConnectTitle: 'Connect your LINE account',
      lineConnectDesc:
        'To continue, please connect your LINE account to receive notifications and support for your car submission.',
      lineConnectBtn: 'Connect LINE account',
      statusIncomplete: 'Incomplete',
      statusActionRequired: 'Action required',
      statusPending: 'Pending',
      statusSubmitted: 'Submitted',
      statusCompleted: 'Completed',
      statusVerified: 'Verified',
      statusPublished: 'Published',
      statusUnknown: 'Unknown',
      lastEdited: 'Last edited',
      uploadDocuments: 'Upload documents',
      continueBtn: 'Continue',
      manageBtn: 'Manage',
      viewBtn: 'View car',
      carSubmitAccepted: 'Accepted',
      carSubmitRejected: 'Rejected',
      carSubmitPending: 'Pending',
      carSubmitSentOn: 'Submitted on',
      carSubmitContinue: 'Continue',
      pullToRefresh: 'Pull down to refresh',
      releaseToRefresh: 'Release to refresh',
      refreshing: 'Refreshing...',
      refreshComplete: 'Refresh complete',
      proIntro: {
        title: 'Earn more with HAUP Pro',
        subtitle:
          'Before you list your car, discover how Pro hosts earn significantly more — with less effort.',
        proLabel: 'Pro',
        proBadge: 'Premium plan',
        proBullet1:
          'Listed on HAUP platforms and our travel partner sites — *Trip.com, Klook* seen by far more renters',
        proBullet2: '*Bookings confirm instantly,* no waiting on your approval',
        proBullet3: 'Up to *3x more reservations*',
        proBullet4:
          'Monitor your vehicle *in real time* and enjoy a *seamless contactless* rental experience',
        proBullet5: 'Choose between *two revenue sharing plans*',
        learnMoreRevenuePlans: 'Learn more about revenue plans',
        proNote: "Pro requires a HAUP IoT device. We'll walk you through it the next step.",
        learnMorePro: 'Learn more about Pro',
        starterLabel: 'Starter',
        starterBullet1: 'Listed only on our platform for renters to find',
        starterBullet2: 'You review and accept each booking request',
        starterBullet3: 'Nothing to install, but less reservations',
        starterBullet4: 'Manage reservations manually and meet renters for key handovers.',
        starterBullet5: 'Set your own earnings and receive the price you choose for your car.',
        learnMoreStarter: 'Learn more about Starter',
        continueWithProBtn: 'Continue with Pro',
        continueWithStarterBtn: 'Continue with Starter',
        earningsCalculator: {
          entryTitle: 'Calculate your earnings',
          entrySubtitle: 'Estimate your earnings in 10 seconds',
          modalTitle: 'How much can your vehicle earn?',
          modalSubtitle: 'Fill in your car details and see the difference between Pro and Starter.',
          brandLabel: 'Brand',
          brandPlaceholder: 'Select your car brand',
          modelLabel: 'Model',
          modelPlaceholder: 'Select your car model',
          yearLabel: 'Model year',
          yearPlaceholder: 'Select your car model year',
          calculateBtn: 'Calculate my earnings',
          resultsTitle: 'Your potential earnings',
          resultsSubtitle:
            'Estimates based on average platform utilisation. Actual earnings may vary depending on location, season, and demand.',
          perDayRateLabel: 'Per day rate',
          perDayRateNote: 'based on model and year',
          perMonthRateLabel: 'Per month rate',
          perMonthRateNote: 'Discounted long-term monthly rate',
          standardPricingNote:
            'This is based on HAUP standard pricing. You can also set your own pricing.',
          starterLabel: 'Starter',
          proLabel: 'Verified Pro',
          utilisationRateLabel: 'Utilisation rate',
          estRentalDaysLabel: 'Est. rental day per month',
          estIncomeLabel: 'Est. income per month',
          listedOnlyOnLabel: 'Listed only on',
          listedOnLabel: 'Also listed on',
          proUtilisationBannerTitle: 'Pro hosts get 80% utilisation',
          proUtilisationBannerSubtitle:
            'Listings on Trip.com & Klook and instant booking confirmation can attract more renters.',
          disclaimer:
            'Estimate only, based on typical booking patterns for similar cars on our platform. Actual earnings vary by location, condition, and demand.',
          continueWithProBtn: 'Continue with Pro',
          backToOverviewBtn: 'Back to overview',
          notFoundError: 'No pricing found for this vehicle.',
        },
        planDetails: {
          backBtn: 'Back',
          featureListLabel: 'FEATURE LIST',
          starterColLabel: 'STARTER',
          proColLabel: 'VERIFIED-PRO',
          featureRows: [
            { label: 'Additional equipments', starter: '✕', pro: 'HAUP IoT GPS' },
            { label: 'Renting', starter: 'Daily', pro: 'Hourly / Daily' },
            {
              label: 'Minimum Advance Booking',
              starter: '24 hours in advance',
              pro: '15 mins in advance',
            },
            { label: 'Unlocking the car', starter: 'Car key', pro: 'App unlock' },
            {
              label: 'Commercial insurance (Partner-provided)',
              starter: 'Optional',
              pro: 'Mandatory',
            },
            { label: 'Vehicle maintenance', starter: 'Owner', pro: 'HAUP' },
            { label: 'Revenue earning', starter: 'Net Revenue', pro: 'Revenue Sharing' },
            {
              label: 'Contract security deposit per vehicle',
              starter: 'THB 500',
              pro: 'THB 2,000',
            },
            { label: 'Equipment installation cost', starter: '✕', pro: 'THB 1,070 per vehicle' },
            {
              label: 'Monthly equipment service fee',
              starter: '✕',
              pro: 'THB 490 per vehicle per month',
            },
          ],
          pro: {
            title: 'Pro plan details',
            bullets: [
              '*No need* to meet renters',
              'Need to park the car at *HAUP stations*',
              'Renters can book anytime they want *only with 15 minutes in advance*',
              'Open for service for a *minimum of 30 minutes*',
              "Choose from *two revenue sharing plans* that best matches how you'd like to manage your car.",
              'Need to have or buy *insurance*',
            ],
            linkLabel: 'Learn more about revenue plans',
            linkAfterIndex: 4,
          },
          starter: {
            title: 'Starter plan details',
            bullets: [
              '*Meet drivers* to handover key',
              '*No need* to park the car at HAUP stations',
              'Renters can makes a reservation *24 hours in advance*',
              'Open for service *only daily and above*',
              'Set your *own earnings and receive the price you choose* for your car.',
            ],
            linkLabel: 'Learn more about net revenue',
            linkAfterIndex: 4,
          },
        },
        revenuePlans: {
          title: 'Compare revenue plans',
          subtitle:
            'Compare the benefits and responsibilities of each plan to find the option that best suits your needs.',
          plan5545Title: '55% Owner, 45% HAUP',
          plan5545Subtitle: 'Airtime fee is not included',
          plan5545Desc:
            'HAUP manages your vehicle operations and maintenance, but airtime fee THB 490/month is not included and will be deducted separately.',
          plan5050Title: '50% Owner, 50% HAUP',
          plan5050Subtitle: 'Airtime fee included',
          plan5050Desc:
            'HAUP manages your vehicle operations and maintenance. The monthly airtime fee is included.',
          featuresLabel: 'FEATURES',
          col5050Label: '50/50',
          col5545Label: '55/45',
          rows: [
            { label: 'Monthly airtime fee', col1Check: true, col2Check: false },
            { label: 'Monthly parking fee', col1Check: true, col2Check: true },
            { label: 'Vehicle maintenance', col1Check: true, col2Check: true },
            { label: 'Maintenance coordination', col1Check: true, col2Check: true },
          ],
        },
        netRevenue: {
          title: 'Net revenue',
          description:
            'Net Revenue is the final amount you receive from each completed rental. The only deduction applied is a 3% withholding tax required by law. No additional platform fees, commissions, or hidden charges will be deducted from your earnings.',
          exampleLabel: 'Example',
          exampleIntro: 'If you set your earnings at THB 1,000:',
          bullet1: 'Your set earnings: THB 1,000',
          bullet2: '3% withholding tax: THB 30',
          bullet3: 'Net revenue received: THB 970',
          noteText:
            'HAUP may adjust the final renter price based on market demand and promotions, but your earnings will always be based on the amount you set.',
        },
        iotDevice: {
          title: 'Install a HAUP IOT device',
          subtitle:
            'This small device is what makes instant booking and real-time protection possible for your car.',
          deviceTitle: 'HAUP IOT - GPS',
          deviceDesc:
            'A small smart device installed in your car that enables remote access, vehicle monitoring, and contactless rentals.',
          compatibleTitle: 'Compatible with many popular car brands',
          moreLabel: '+more',
          whyTitle: 'Why install a HAUP IoT device?',
          features: [
            { title: 'Live location', desc: "Track your car's location in real time." },
            {
              title: 'App lock/unlock via mobile app',
              desc: 'Enjoy contactless handovers with remote lock/unlock.',
            },
            { title: 'Vehicle status', desc: "View your vehicle's status remotely." },
            { title: 'Smart alerts', desc: 'Get notified about important vehicle events.' },
            {
              title: 'Vehicle monitoring & alerts',
              desc: 'Stay informed with important vehicle notifications.',
            },
          ],
          installationFeeLabel: 'Total installation fee',
          installationFeeValue: 'THB 1,070',
          installationFeeNote: '(incl. VAT)',
          dueTodayLabel: 'Total due today',
          dueTodayValue: 'THB 99.00',
          dueTodayNote: '(Non-refundable)',
          installmentText:
            'The remaining *THB 971* will be paid in *10 monthly installments* from your *Revenue Wallet* or preferred payment method.',
          payBtn: 'Pay THB 99 to continue with Pro',
          goBackBtn: 'Go back',
        },
        takeALook: {
          title: 'Take a look before you decide',
          subtitle: "No pressure — here's exactly what's different, side by side.",
          featureLabel: 'FEATURE',
          proLabel: 'PRO',
          starterLabel: 'STARTER',
          rows: [
            { label: 'Listed on Trip.com & Klook', proCheck: true, starterCheck: false },
            { label: 'Instant booking confirmation', proCheck: true, starterCheck: false },
            { label: 'Priority search ranking', proCheck: true, starterCheck: false },
            { label: 'Real-time GPS tracking', proCheck: true, starterCheck: false },
            { label: 'Enhanced vehicle protection', proCheck: true, starterCheck: false },
            { label: 'Listed on HAUP platforms', proCheck: true, starterCheck: true },
            { label: 'Basic booking management', proCheck: true, starterCheck: true },
          ],
          note: "Pro is optional, and you can switch to it later at any time from your car's settings. Starter still gets your car listed and earning — Pro simply opens up more places for renters to find it.",
          switchToProBtn: 'Switch to Pro',
          continueStarterBtn: 'Continue with Starter anyway',
        },
        payment: {
          title: 'Complete your payment',
          subtitle: 'One-time fee for your HAUP device and installation.',
          infoNote:
            "After completing your car submission, you'll be able to schedule your HAUP IoT installation appointment.",
          paymentDetailsLabel: 'Payment details',
          depositLabel: 'Installation deposit',
          processingFeeLabel: 'Payment processing fee',
          processingFeeNote: '{percent}% of installation fee',
          totalLabel: 'Total payable today',
          selectMethodLabel: 'Payment Method',
          cardLabel: 'Debit/credit card',
          scbPromptPayLabel: 'SCB PromptPay',
          alipayLabel: 'Alipay',
          wechatPayLabel: 'WeChat Pay',
          qrPromptPayLabel: 'PromptPay',
          cardNumberLabel: 'Credit/Debit card number',
          cardNumberPlaceholder: '1234 5678 9012 3456',
          cardHolderLabel: 'Credit/debit card holder',
          cardHolderPlaceholder: 'JOHN DOE',
          expiryLabel: 'Expiry date',
          cvvLabel: 'CVV/CVC',
          payBtnPrefix: 'Pay THB',
          payBtnSuffix: 'to submit car with Pro',
          processingBtn: 'Processing payment...',
          depositBannerTitle: 'You have a paid installation deposit',
          depositBannerDesc:
            'Your THB 99 deposit is ready to use. List a car with Pro and you will not be charged again.',
          depositBannerCta: 'List a car with Pro',
          alreadyPaidTitle: 'Installation deposit already paid',
          alreadyPaidDesc:
            'You have already paid the THB 99 installation deposit. We will apply it to the car you are listing now, so you will not be charged again.',
          alreadyPaidContinue: 'Continue',
          processingModalTitle: 'Payment processing',
          processingModalDesc: "Please wait, don't refresh the page",
          goBackBtn: 'Go back',
          qrModalTitle: '{method} Payment',
          qrModalSubtitle: 'Scan this QR code with your mobile banking app to complete the payment',
          qrWaitingText: 'Waiting for payment confirmation...',
          qrNote: 'Please do not close this window until payment is confirmed',
        },
      },
    },
    finish: {
      loadingText: 'Loading...',
      submittingTitle: 'Submitting your car',
      submittingDesc: "Please wait, don't refresh the page",
      noVehicleData: 'No vehicle data available',
      requestBookingBadge: 'Request booking',
      instantBookingBadge: 'Instant booking',
      meetWithOwner: 'Meet with owner',
      appUnlock: 'App unlock',
      seatsLabel: 'seats',
      successTitle: 'Success! Your car is now listed on our platform.',
      viewCarBtn: 'View your car',
      lineTitle: 'Connect with us on LINE',
      lineDesc:
        'Before proceeding with the remaining steps, please connect with us on LINE. Our team will guide you through the process and help you track your request directly.',
      lineChat: 'Chat with us',
      stepsTitle: 'Next steps to complete',
      step1Title: 'Submission completed',
      step2Title: 'Your car is registered on the platform',
      step3Title: 'Download the app',
      step3Desc:
        'You need to download our app to manage your car listing, respond to requests, and track your earnings.',
      step3ManageBtn: 'Manage your car',
      step3DownloadBtn: 'Download app',
      incompleteBadge: 'Incomplete',
      doneBtn: 'Done',
      manageBtn: 'Manage your car',
      proAllSetTitle: "You're all set!",
      proAllSetSubtitle:
        'Your car has been submitted successfully and your IoT installation has been scheduled.',
      proIotScheduledTitle: 'IoT Installation scheduled',
      proStartEarningTitle: 'To start earning, complete these required steps',
      proStartEarningDesc:
        'You have to complete the remaining steps to start earnings from the bookings.',
      proStepSubmitCarInfo: 'Submit car information',
      proStepSetPricing: 'Set the pricing',
      proStepScheduleIot: 'Schedule IoT installation',
      proStepDownloadApp: 'Download app',
      proStepUploadImagesDocs: 'Upload images and documents',
      proStepSignContract: 'Sign the contract',
      proStepCompleteIot: 'Complete IoT installation',
      proStepSelectParking: 'Select vehicle parking with HAUP',
      proManageBtn: 'Manage your car',
      proFinishBtn: 'Finish',
    },
    paymentCallback: {
      processingTitle: 'Checking your payment',
      processingDesc: 'Please wait while we verify your payment.',
      successTitle: 'Installation deposit paid',
      successDesc: 'Your installation deposit has been received successfully.',
      refIdLabel: 'Reference ID',
      whatsNextLabel: "What's next?",
      step1: 'Submit your car to complete the listing',
      step2: 'Schedule your IoT installation',
      failedTitle: 'Payment failed',
      failedDesc: "We couldn't confirm your payment. Please try again from the original tab.",
      continueBtn: 'Continue',
      closeBtn: 'Close this window',
    },
    proPricing: {
      revenuePlanTitle: 'Choose your revenue sharing plan',
      plan5050Label: '50% owner, 50% HAUP',
      plan5545Label: '55% owner, 45% HAUP',
      plan5050Tagline: 'All-inclusive, worry-free experience',
      plan5545Tagline: 'Higher share, more flexibility',
      airtimeIncluded: 'Monthly airtime fee included',
      airtimeNotIncluded: 'Monthly airtime fee not included',
      maintenanceIncluded: 'Vehicle maintenance and parking fee included',
      operationsManaged: 'Vehicle operations managed by HAUP',
      idealForLabel: 'Ideal for :',
      plan5050IdealFor: 'Owners who prefer an all-inclusive plan with fewer expenses to manage.',
      plan5545IdealFor:
        "Owners who prefer a higher revenue share and don't mind paying the monthly airtime fee separately.",
      learnMorePlan: 'Learn more about this plan',
      comparePlans: 'Compare revenue sharing plans',
      whatsIncludedLabel: "What's included?",
      plan5050ModalDesc: 'All-inclusive, worry-free experience',
      plan5545ModalDesc: 'Higher earnings with more flexibility',
      plan5050Benefits: [
        'Monthly airtime fee included',
        'Monthly parking fee included',
        'Vehicle listed on HAUP and partner platforms',
        'Instant bookings and contactless rental experience',
        'Vehicle maintenance and servicing managed by HAUP',
        'Real-time vehicle monitoring via HAUP IoT',
      ],
      plan5545Benefits: [
        'Monthly airtime fee is not included',
        'Monthly parking fee included',
        'Vehicle listed on HAUP and partner platforms',
        'Instant bookings and contactless rental experience',
        'Vehicle maintenance and servicing managed by HAUP',
        'Real-time vehicle monitoring via HAUP IoT',
      ],
      insuranceQuestion: 'Do you have insurance for your car?',
      insuranceYes: 'Yes, I have',
      insuranceNo: "No, I don't have",
      insuranceTypeQuestion: 'Which type of insurance do you have?',
      insurancePersonal: 'Personal insurance',
      insuranceCommercial: 'Commercial insurance',
      insurancePackageTitle: 'Select insurance package',
      insurancePackageMostPick: 'Most pick',
      insurancePackageDesc: 'Commercial insurance for',
      monthsLabel: 'months',
      standardPriceSectionTitle: 'Standard rental price',
    },
    proReview: {
      title: "You've completed the main steps!",
      subtitle: 'Review your details before submitting your car to the platform.',
      revenueShareLabel: 'Revenue sharing',
      dailyLabel: 'Daily rental',
      weeklyLabel: 'Weekly rental',
      monthlyLabel: 'Monthly rental',
      yearlyLabel: 'Yearly rental',
      perDay: 'THB/day',
      perWeek: 'THB/week',
      perMonth: 'THB/month',
      perYear: 'THB/year',
      iotScheduleTitle: 'IoT Installation schedule',
      submitBtn: 'Confirm and submit now',
    },
    proAppointment: {
      title: 'Schedule your IOT installation',
      subtitle:
        'Choose a convenient date and time for your HAUP IoT device installation. Our certified technician will install and activate the device, so you can enjoy all the benefits of Pro Listing.',
      selectDateTimeLabel: 'Select date and time',
      selectTimeLabel: 'Select time',
      garageName: 'HAUP Garage',
      garageAddress:
        '12 Phaya Thai Rd, Khwaeng Thung Phaya Thai, Khet Ratchathewi, Krung Thep Maha Nakhon 104000',
      directionsLink: 'See directions on Google Maps',
      durationNote:
        'Installation takes about 30–45 minutes. Please have your car and its keys available at the scheduled time.',
      confirmBtn: 'Confirm and submit',
      goBackBtn: 'Go back',
      exitBtn: 'Exit',
      welcomeModal: {
        stepNumber: 'Step 3',
        title: 'Schedule IoT installation',
        description:
          "Choose your preferred installation date and time for your HAUP IoT device. Once installed, you'll unlock Pro features such as instant bookings, contactless rentals, and real-time vehicle monitoring to help you manage your car more easily.",
        imageAlt: 'Schedule installation icon',
        nextButton: 'Next',
        backButton: 'Back',
      },
    },
  },
}
